//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.20.0.0 (NJsonSchema v10.9.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

import { mergeMap as _observableMergeMap, catchError as _observableCatch } from 'rxjs/operators';
import { Observable, throwError as _observableThrow, of as _observableOf } from 'rxjs';
import { Injectable, Inject, Optional, InjectionToken } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse, HttpResponseBase } from '@angular/common/http';

export const API_USER_MANAGEMENT_BASE_URL = new InjectionToken<string>('API_USER_MANAGEMENT_BASE_URL');

@Injectable({
    providedIn: 'root'
})
export class AccountUMClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_USER_MANAGEMENT_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param language (optional) 
     * @return Success
     */
    validateEmail(emailVerificationCode: string, language: string | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/account/confirm-email/{emailVerificationCode}?";
        if (emailVerificationCode === undefined || emailVerificationCode === null)
            throw new Error("The parameter 'emailVerificationCode' must be defined.");
        url_ = url_.replace("{emailVerificationCode}", encodeURIComponent("" + emailVerificationCode));
        if (language !== undefined && language !== null)
            url_ += "language=" + encodeURIComponent("" + language) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processValidateEmail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processValidateEmail(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processValidateEmail(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param language (optional) 
     * @return Success
     */
    unsubscribeEmail(language: string | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/account/unsubscribe-email?";
        if (language !== undefined && language !== null)
            url_ += "language=" + encodeURIComponent("" + language) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUnsubscribeEmail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUnsubscribeEmail(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUnsubscribeEmail(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * used to update profile information
     * @param request (optional) contains the profile data
     * @return Success
     */
    updateProfile(request: UpdateProfileRequest | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/Account/profile";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("patch", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateProfile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateProfile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateProfile(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * used to create profile information
     * @param request (optional) contains the profile data
     * @return Success
     */
    createBartenderProfile(request: CreateBartenderProfileRequest | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/Account/profile";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateBartenderProfile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateBartenderProfile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateBartenderProfile(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * used to get profile information
     * @return Success
     */
    getProfile(): Observable<ProfileResponse> {
        let url_ = this.baseUrl + "/api/Account/profile";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetProfile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProfile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProfileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProfileResponse>;
        }));
    }

    protected processGetProfile(response: HttpResponseBase): Observable<ProfileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProfileResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Update profile when onboarding user from landing page
     * @param request (optional) contains the profile data
     * @return Success
     */
    updateUserProfileWhenOnboarding(request: UpdateProfileWhenOnboardingRequest | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/Account/profile-when-onboarding";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("patch", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateUserProfileWhenOnboarding(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateUserProfileWhenOnboarding(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateUserProfileWhenOnboarding(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * used to update profile information
     * @param request (optional) contains the profile data
     * @return Success
     */
    updateProfileTags(request: UpdateProfileTagRequest | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/Account/tag";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("patch", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateProfileTags(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateProfileTags(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateProfileTags(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * used to update user's email (send validation email if different than current)
     * @param request (optional) 
     * @return Validateion email sent succesfully. Check email and validate it using the link received there.
     */
    changeEmail(request: ChangeEmailRequest | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/Account/changeEmail";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("patch", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processChangeEmail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processChangeEmail(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processChangeEmail(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 304) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("NotModified, the new email provided is already the current validated email.", status, _responseText, _headers);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Invalid request. Email probably exists, already validated for another account.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Allows user to change the phone number
    This will start another phone verification session with nexmo and send SMS/TTS to user.
    Call ChangePhoneValidate api action after this with OTP code received by SMS.
     * @param request (optional) 
     * @return TOTP code sent to newPhoneNumber. Use verificationId to call ChangePhoneValidate.
     */
    changePhone(request: ChangePhoneRequest | null | undefined): Observable<ChangePhoneResponse> {
        let url_ = this.baseUrl + "/api/Account/profile/changePhone";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("patch", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processChangePhone(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processChangePhone(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ChangePhoneResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ChangePhoneResponse>;
        }));
    }

    protected processChangePhone(response: HttpResponseBase): Observable<ChangePhoneResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ChangePhoneResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 409) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Account with provided phone number allready exists.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Validates the OTP code received by SMS/TTS against the validation id and if correct, it will change the user phone number in the profile.
    The token is not changed (user id is the same), but it might be a bit stale (should contain the old phone number)
    It would be best to call refresh token after this to update the token with the new phone number.
     * @param request (optional) 
     * @return Success
     */
    changePhoneValidate(request: ChangePhoneValidateRequest | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/Account/profile/changePhoneValidate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("patch", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processChangePhoneValidate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processChangePhoneValidate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processChangePhoneValidate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param request (optional) 
     * @return Success
     */
    changeTermAndConditionsUrl(request: ChangeTermAndConditionsUrlRequest | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/Account/profile/changeTermAndConditionsUrl";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("patch", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processChangeTermAndConditionsUrl(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processChangeTermAndConditionsUrl(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processChangeTermAndConditionsUrl(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Create new profile
     * @param x_rest_api_key (optional) 
     * @param request (optional) contains the profile data
     * @return Success
     */
    createProfile(x_rest_api_key: string | null | undefined, request: CreateProfileRequest | null | undefined): Observable<CreateProfileResponse> {
        let url_ = this.baseUrl + "/api/account/profiles";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "x-rest-api-key": x_rest_api_key !== undefined && x_rest_api_key !== null ? "" + x_rest_api_key : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateProfile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateProfile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CreateProfileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CreateProfileResponse>;
        }));
    }

    protected processCreateProfile(response: HttpResponseBase): Observable<CreateProfileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 201) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = CreateProfileResponse.fromJS(resultData201);
            return _observableOf(result201);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 409) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ErrorResponse.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ErrorResponse.fromJS(resultData500);
            return throwException("Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * used to create profile information
     * @param request (optional) contains the profile data
     * @return Success
     */
    createConsumerProfile(request: CreateConsumerProfileRequest | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/Account/consumerProfile";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateConsumerProfile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateConsumerProfile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateConsumerProfile(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * used to create profile information
     * @param request (optional) contains the profile data
     * @return Success
     */
    createStaffProfile(request: CreateStaffProfileRequest | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/Account/staffProfile";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateStaffProfile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateStaffProfile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateStaffProfile(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * used by the email link to actually mark the account with email as validated
     * @param emailVerificationCode (optional) the code included in the link received by email
     * @return Success
     */
    validateEmail2(emailVerificationCode: string | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/Account/validateEmail?";
        if (emailVerificationCode !== undefined && emailVerificationCode !== null)
            url_ += "emailVerificationCode=" + encodeURIComponent("" + emailVerificationCode) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processValidateEmail2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processValidateEmail2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processValidateEmail2(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Trigger account recovery using email.
    When a user changes phone number and does not have access to the original phone
    number anymore, he can recover his original account using email verification.
    We will send a
     * @param email (optional) email
     * @param phoneVerificationId (optional) phoneVerrificationId that should allready be validated using ValidatePhoneCode
     * @param language (optional) The language.
     * @return Success
     */
    recoverAccountByEmail(email: string | null | undefined, phoneVerificationId: string | null | undefined, language: string | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/Account/recoverByEmail?";
        if (email !== undefined && email !== null)
            url_ += "email=" + encodeURIComponent("" + email) + "&";
        if (phoneVerificationId !== undefined && phoneVerificationId !== null)
            url_ += "phoneVerificationId=" + encodeURIComponent("" + phoneVerificationId) + "&";
        if (language !== undefined && language !== null)
            url_ += "language=" + encodeURIComponent("" + language) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRecoverAccountByEmail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRecoverAccountByEmail(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processRecoverAccountByEmail(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * validate email recovery code
     * @param recoverCode (optional) the code received by email (should be in the link received by email)
     * @return Success
     */
    validateEmailRecovery(recoverCode: string | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/Account/validateEmailRecovery?";
        if (recoverCode !== undefined && recoverCode !== null)
            url_ += "recoverCode=" + encodeURIComponent("" + recoverCode) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processValidateEmailRecovery(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processValidateEmailRecovery(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processValidateEmailRecovery(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getAvatarUploadUrl(): Observable<string> {
        let url_ = this.baseUrl + "/api/Account/avatarUploadUrl";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAvatarUploadUrl(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAvatarUploadUrl(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processGetAvatarUploadUrl(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * call this after you upload the image to the url provided by /avatarUploadUrl
     * @return Success
     */
    updateAvatar(): Observable<ImageSaveResult> {
        let url_ = this.baseUrl + "/api/Account/updateAvatar";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateAvatar(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateAvatar(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ImageSaveResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ImageSaveResult>;
        }));
    }

    protected processUpdateAvatar(response: HttpResponseBase): Observable<ImageSaveResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ImageSaveResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getUserTags(): Observable<UserTag[]> {
        let url_ = this.baseUrl + "/api/Account/tags";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUserTags(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserTags(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserTag[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserTag[]>;
        }));
    }

    protected processGetUserTags(response: HttpResponseBase): Observable<UserTag[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(UserTag.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * search accounts that have my organization and Staff role
     * @return Success
     */
    getStaffForMyOrganizationAsOwner(): Observable<ProfileQueryResponse> {
        let url_ = this.baseUrl + "/api/Account/staffForMyOrganization";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetStaffForMyOrganizationAsOwner(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetStaffForMyOrganizationAsOwner(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProfileQueryResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProfileQueryResponse>;
        }));
    }

    protected processGetStaffForMyOrganizationAsOwner(response: HttpResponseBase): Observable<ProfileQueryResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProfileQueryResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getUserInsights(phone: string): Observable<User> {
        let url_ = this.baseUrl + "/api/Account/get-user-insights-by-phone/{phone}";
        if (phone === undefined || phone === null)
            throw new Error("The parameter 'phone' must be defined.");
        url_ = url_.replace("{phone}", encodeURIComponent("" + phone));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUserInsights(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserInsights(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<User>;
                }
            } else
                return _observableThrow(response_) as any as Observable<User>;
        }));
    }

    protected processGetUserInsights(response: HttpResponseBase): Observable<User> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = User.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * used to archive account - prepare for deletion
     * @return Success
     */
    deleteAccount(): Observable<void> {
        let url_ = this.baseUrl + "/api/Account/delete-account";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteAccount(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteAccount(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteAccount(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Activate Account
     * @return Success
     */
    activateAccount(): Observable<void> {
        let url_ = this.baseUrl + "/api/Account/activate-account";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processActivateAccount(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processActivateAccount(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processActivateAccount(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Change subscription channel status for Clever Tap
     * @param request (optional) 
     * @return Success
     */
    changeSubscriptionChannelStatus(request: ChangeSubscriptionChannelStatusRequest | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/Account/change-subscription-channel-status";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processChangeSubscriptionChannelStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processChangeSubscriptionChannelStatus(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processChangeSubscriptionChannelStatus(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class AdminAccountUMClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_USER_MANAGEMENT_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * used to lock/unlock the phone by id
     * @param isLockRequest (optional) 
     * @return Success
     */
    updateDeviceStatus(phoneDeviceId: string, isLockRequest: boolean | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/admin/Account/phoneDevice/{phoneDeviceId}/status?";
        if (phoneDeviceId === undefined || phoneDeviceId === null)
            throw new Error("The parameter 'phoneDeviceId' must be defined.");
        url_ = url_.replace("{phoneDeviceId}", encodeURIComponent("" + phoneDeviceId));
        if (isLockRequest !== undefined && isLockRequest !== null)
            url_ += "isLockRequest=" + encodeURIComponent("" + isLockRequest) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("patch", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateDeviceStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateDeviceStatus(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateDeviceStatus(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * used to lock/unlock the account by id
     * @param isLockRequest (optional) 
     * @return Success
     */
    updateAccountStatus(accountId: string, isLockRequest: boolean | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/admin/Account/accounts/{accountId}/status?";
        if (accountId === undefined || accountId === null)
            throw new Error("The parameter 'accountId' must be defined.");
        url_ = url_.replace("{accountId}", encodeURIComponent("" + accountId));
        if (isLockRequest !== undefined && isLockRequest !== null)
            url_ += "isLockRequest=" + encodeURIComponent("" + isLockRequest) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("patch", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateAccountStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateAccountStatus(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateAccountStatus(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * lists all the the phones in the system registered so far
     * @return Success
     */
    getAllDevices(): Observable<PhoneDevice[]> {
        let url_ = this.baseUrl + "/api/admin/Account/phoneDevice/All";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllDevices(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllDevices(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PhoneDevice[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PhoneDevice[]>;
        }));
    }

    protected processGetAllDevices(response: HttpResponseBase): Observable<PhoneDevice[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PhoneDevice.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * search accounts using filters. use next token along with the same filters to retrieve the next page
     * @param filter (optional) 
     * @return Success
     */
    searchAccounts(filter: ProfileQueryFilter | null | undefined): Observable<ProfileQueryResponse> {
        let url_ = this.baseUrl + "/api/admin/Account/accounts/search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(filter);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSearchAccounts(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearchAccounts(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProfileQueryResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProfileQueryResponse>;
        }));
    }

    protected processSearchAccounts(response: HttpResponseBase): Observable<ProfileQueryResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProfileQueryResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Search accounts using simple filters. Use next token along with the same filters to retrieve the next page.
     * @param filter (optional) 
     * @return Success
     */
    simpleSearchAccounts(filter: SimpleProfileQueryFilter | null | undefined): Observable<ProfileQueryResponse> {
        let url_ = this.baseUrl + "/api/admin/Account/accounts/simpleSearch";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(filter);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSimpleSearchAccounts(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSimpleSearchAccounts(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProfileQueryResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProfileQueryResponse>;
        }));
    }

    protected processSimpleSearchAccounts(response: HttpResponseBase): Observable<ProfileQueryResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProfileQueryResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * get basic profile information
     * @return Success
     */
    getProfileById(id: string): Observable<ProfileResponse> {
        let url_ = this.baseUrl + "/api/admin/Account/accounts/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetProfileById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProfileById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProfileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProfileResponse>;
        }));
    }

    protected processGetProfileById(response: HttpResponseBase): Observable<ProfileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProfileResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * get list of sessions created for an account
     * @return Success
     */
    getAccountSessionHistory(accountId: string): Observable<AccountDeviceSessionsResponse[]> {
        let url_ = this.baseUrl + "/api/admin/Account/accounts/{accountId}/sessions";
        if (accountId === undefined || accountId === null)
            throw new Error("The parameter 'accountId' must be defined.");
        url_ = url_.replace("{accountId}", encodeURIComponent("" + accountId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAccountSessionHistory(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAccountSessionHistory(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AccountDeviceSessionsResponse[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AccountDeviceSessionsResponse[]>;
        }));
    }

    protected processGetAccountSessionHistory(response: HttpResponseBase): Observable<AccountDeviceSessionsResponse[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AccountDeviceSessionsResponse.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * get all accounts that logged in using the same phone
     * @return Success
     */
    getAccountsByPhoneId(phoneId: string): Observable<ProfileResponse[]> {
        let url_ = this.baseUrl + "/api/admin/Account/phone/{phoneId}/accounts";
        if (phoneId === undefined || phoneId === null)
            throw new Error("The parameter 'phoneId' must be defined.");
        url_ = url_.replace("{phoneId}", encodeURIComponent("" + phoneId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAccountsByPhoneId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAccountsByPhoneId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProfileResponse[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProfileResponse[]>;
        }));
    }

    protected processGetAccountsByPhoneId(response: HttpResponseBase): Observable<ProfileResponse[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ProfileResponse.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Updates the name and phone number of the user. If email is not the current active email, it will create a email validation request and will send a validation email to the user.
    Only after validation, the email will be saved to the account.
     * @param request (optional) 
     * @return account updated
     */
    adminUpdateProfile(request: AdminUpdateProfileRequest | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/admin/Account/updateProfile";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("patch", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAdminUpdateProfile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAdminUpdateProfile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processAdminUpdateProfile(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData400) {
                result400 = {} as any;
                for (let key in resultData400) {
                    if (resultData400.hasOwnProperty(key))
                        (<any>result400)![key] = resultData400[key] ? ModelStateEntry.fromJS(resultData400[key]) : new ModelStateEntry();
                }
            }
            else {
                result400 = <any>null;
            }
            return throwException("Validation exception. Invalid data in the request.", status, _responseText, _headers, result400);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 304) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("No change. The account was not modified.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get CSV for staff bulk import upload URL
     * @return Success
     */
    getCsvStaffBulkImportUploadUrl(organizationId: number, key: string): Observable<string> {
        let url_ = this.baseUrl + "/api/admin/Account/getCsvStaffBulkImportUploadUrl/{organizationId}/{key}";
        if (organizationId === undefined || organizationId === null)
            throw new Error("The parameter 'organizationId' must be defined.");
        url_ = url_.replace("{organizationId}", encodeURIComponent("" + organizationId));
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCsvStaffBulkImportUploadUrl(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCsvStaffBulkImportUploadUrl(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processGetCsvStaffBulkImportUploadUrl(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get the account ids for that have their birthday on the specified month and day.
     * @return Success
     */
    getIdsForBirthday(month: number, day: number): Observable<string[]> {
        let url_ = this.baseUrl + "/api/admin/Account/getIdsForBirthday/{month}/{day}";
        if (month === undefined || month === null)
            throw new Error("The parameter 'month' must be defined.");
        url_ = url_.replace("{month}", encodeURIComponent("" + month));
        if (day === undefined || day === null)
            throw new Error("The parameter 'day' must be defined.");
        url_ = url_.replace("{day}", encodeURIComponent("" + day));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetIdsForBirthday(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetIdsForBirthday(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string[]>;
        }));
    }

    protected processGetIdsForBirthday(response: HttpResponseBase): Observable<string[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get user ipaddress.
     * @return Success
     */
    getUserIpAddress(): Observable<string> {
        let url_ = this.baseUrl + "/api/admin/Account/ip-tracker";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUserIpAddress(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserIpAddress(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processGetUserIpAddress(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Create marketing consent tag for user account
     * @param marketingConsentRequest (optional) 
     * @return Success
     */
    createMarketingConsentTag(accountId: string, advertiserId: string, marketingConsentRequest: MarketingConsentRequest | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/admin/Account/{accountId}/create-marketing-consent-tag/{advertiserId}";
        if (accountId === undefined || accountId === null)
            throw new Error("The parameter 'accountId' must be defined.");
        url_ = url_.replace("{accountId}", encodeURIComponent("" + accountId));
        if (advertiserId === undefined || advertiserId === null)
            throw new Error("The parameter 'advertiserId' must be defined.");
        url_ = url_.replace("{advertiserId}", encodeURIComponent("" + advertiserId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(marketingConsentRequest);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateMarketingConsentTag(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateMarketingConsentTag(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateMarketingConsentTag(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class AdvertiserWhitelistUMClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_USER_MANAGEMENT_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @return Success
     */
    getAdvertiserWhitelists(): Observable<AdvertiserWhiteList[]> {
        let url_ = this.baseUrl + "/api/advertiser-whitelist";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAdvertiserWhitelists(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAdvertiserWhitelists(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AdvertiserWhiteList[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AdvertiserWhiteList[]>;
        }));
    }

    protected processGetAdvertiserWhitelists(response: HttpResponseBase): Observable<AdvertiserWhiteList[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AdvertiserWhiteList.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param advertiserWhiteList (optional) 
     * @return Success
     */
    createAdvertiserWhitelist(advertiserWhiteList: AdvertiserWhiteList | null | undefined): Observable<AdvertiserWhiteList> {
        let url_ = this.baseUrl + "/api/advertiser-whitelist";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(advertiserWhiteList);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateAdvertiserWhitelist(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateAdvertiserWhitelist(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AdvertiserWhiteList>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AdvertiserWhiteList>;
        }));
    }

    protected processCreateAdvertiserWhitelist(response: HttpResponseBase): Observable<AdvertiserWhiteList> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AdvertiserWhiteList.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param deleteRequest (optional) 
     * @return Success
     */
    deleteAdvertiserWhitelist(deleteRequest: AuthorizationDeleteRequest | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/advertiser-whitelist";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(deleteRequest);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteAdvertiserWhitelist(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteAdvertiserWhitelist(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteAdvertiserWhitelist(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class ApplicationUserSettingsUMClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_USER_MANAGEMENT_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @return Success
     */
    getByName(name: string): Observable<ApplicationUserSettings> {
        let url_ = this.baseUrl + "/api/ApplicationUserSettings/name/{name}";
        if (name === undefined || name === null)
            throw new Error("The parameter 'name' must be defined.");
        url_ = url_.replace("{name}", encodeURIComponent("" + name));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetByName(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetByName(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationUserSettings>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationUserSettings>;
        }));
    }

    protected processGetByName(response: HttpResponseBase): Observable<ApplicationUserSettings> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApplicationUserSettings.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getByName2(name: string): Observable<ApplicationUserSettings> {
        let url_ = this.baseUrl + "/api/admin/ApplicationUserSettings/name/{name}";
        if (name === undefined || name === null)
            throw new Error("The parameter 'name' must be defined.");
        url_ = url_.replace("{name}", encodeURIComponent("" + name));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetByName2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetByName2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationUserSettings>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationUserSettings>;
        }));
    }

    protected processGetByName2(response: HttpResponseBase): Observable<ApplicationUserSettings> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApplicationUserSettings.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getALl(): Observable<ApplicationUserSettings[]> {
        let url_ = this.baseUrl + "/api/admin/ApplicationUserSettings/all";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetALl(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetALl(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationUserSettings[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationUserSettings[]>;
        }));
    }

    protected processGetALl(response: HttpResponseBase): Observable<ApplicationUserSettings[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ApplicationUserSettings.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param item (optional) 
     * @return Success
     */
    save(item: ApplicationUserSettings | null | undefined): Observable<ApplicationUserSettings> {
        let url_ = this.baseUrl + "/api/admin/ApplicationUserSettings/save";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(item);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSave(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSave(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationUserSettings>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationUserSettings>;
        }));
    }

    protected processSave(response: HttpResponseBase): Observable<ApplicationUserSettings> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApplicationUserSettings.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    deleteUserSettings(id: string): Observable<boolean> {
        let url_ = this.baseUrl + "/api/admin/ApplicationUserSettings/delete/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteUserSettings(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteUserSettings(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processDeleteUserSettings(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class AppVersionUMClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_USER_MANAGEMENT_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param request (optional) 
     * @return Success
     */
    getMinVersion(request: CheckMinVersionRequest | null | undefined): Observable<CheckMinVersionResponse> {
        let url_ = this.baseUrl + "/api/AppVersion/checkMinVersion";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMinVersion(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMinVersion(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CheckMinVersionResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CheckMinVersionResponse>;
        }));
    }

    protected processGetMinVersion(response: HttpResponseBase): Observable<CheckMinVersionResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CheckMinVersionResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class BartenderAppVersionUMClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_USER_MANAGEMENT_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @return Success
     */
    getAllBartenderAppRules(): Observable<BartenderAppRule[]> {
        let url_ = this.baseUrl + "/api/admin/BartenderAppVersion/all";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllBartenderAppRules(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllBartenderAppRules(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BartenderAppRule[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BartenderAppRule[]>;
        }));
    }

    protected processGetAllBartenderAppRules(response: HttpResponseBase): Observable<BartenderAppRule[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(BartenderAppRule.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param rule (optional) 
     * @return Success
     */
    addBartenderAppRule(rule: BartenderAppRule | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/admin/BartenderAppVersion";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(rule);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddBartenderAppRule(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddBartenderAppRule(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processAddBartenderAppRule(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param rule (optional) 
     * @return Success
     */
    updateBartenderAppRule(rule: BartenderAppRule | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/admin/BartenderAppVersion";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(rule);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("patch", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateBartenderAppRule(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateBartenderAppRule(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateBartenderAppRule(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    deleteBartenderAppRule(ruleId: string): Observable<void> {
        let url_ = this.baseUrl + "/api/admin/BartenderAppVersion/{ruleId}";
        if (ruleId === undefined || ruleId === null)
            throw new Error("The parameter 'ruleId' must be defined.");
        url_ = url_.replace("{ruleId}", encodeURIComponent("" + ruleId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteBartenderAppRule(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteBartenderAppRule(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteBartenderAppRule(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class CustomerSupportAuthUMClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_USER_MANAGEMENT_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * Create token for Fresh chat
     * @param freshChatUuid (optional) 
     * @return Success
     */
    createFreshchatToken(freshChatUuid: string | null | undefined): Observable<TokenResponse> {
        let url_ = this.baseUrl + "/api/CustomerSupportAuth/fresh-chat";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(freshChatUuid);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateFreshchatToken(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateFreshchatToken(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TokenResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TokenResponse>;
        }));
    }

    protected processCreateFreshchatToken(response: HttpResponseBase): Observable<TokenResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TokenResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class ExternalOnboardUMClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_USER_MANAGEMENT_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * This endpoint allows external onboarding by creating a session with the onboarding info that is handled after the user is authenticated
     * @return Success
     */
    onboard(id: string): Observable<void> {
        let url_ = this.baseUrl + "/onboard/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processOnboard(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processOnboard(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processOnboard(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class OAuthUMClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_USER_MANAGEMENT_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    authenticate(advertiserId: string, returnUrl: string | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/oauth/{advertiserId}?";
        if (advertiserId === undefined || advertiserId === null)
            throw new Error("The parameter 'advertiserId' must be defined.");
        url_ = url_.replace("{advertiserId}", encodeURIComponent("" + advertiserId));
        if (returnUrl !== undefined && returnUrl !== null)
            url_ += "returnUrl=" + encodeURIComponent("" + returnUrl) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAuthenticate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAuthenticate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processAuthenticate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 302) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Redirect", status, _responseText, _headers);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param code (optional) 
     * @param state (optional) 
     * @return Success
     */
    createTokenAsyncGET(code: string | null | undefined, state: string | null | undefined): Observable<TokenResponse> {
        let url_ = this.baseUrl + "/auth/callback?";
        if (code !== undefined && code !== null)
            url_ += "code=" + encodeURIComponent("" + code) + "&";
        if (state !== undefined && state !== null)
            url_ += "state=" + encodeURIComponent("" + state) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateTokenAsyncGET(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateTokenAsyncGET(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TokenResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TokenResponse>;
        }));
    }

    protected processCreateTokenAsyncGET(response: HttpResponseBase): Observable<TokenResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TokenResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param payload (optional) 
     * @return Success
     */
    createTokenAsyncPOST(payload: TokenRequest | null | undefined): Observable<TokenResponse> {
        let url_ = this.baseUrl + "/oauth/token";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(payload);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateTokenAsyncPOST(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateTokenAsyncPOST(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TokenResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TokenResponse>;
        }));
    }

    protected processCreateTokenAsyncPOST(response: HttpResponseBase): Observable<TokenResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TokenResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class OnboardUMClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_USER_MANAGEMENT_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @return Success
     */
    completeOnboard(onboardSessionId: string): Observable<void> {
        let url_ = this.baseUrl + "/api/Onboard/complete-onboard/{onboardSessionId}";
        if (onboardSessionId === undefined || onboardSessionId === null)
            throw new Error("The parameter 'onboardSessionId' must be defined.");
        url_ = url_.replace("{onboardSessionId}", encodeURIComponent("" + onboardSessionId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("patch", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCompleteOnboard(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCompleteOnboard(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCompleteOnboard(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class PublicAccountUMClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_USER_MANAGEMENT_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * used to get public profile information (name, avatar)
     * @param accountId (optional) 
     * @return Success
     */
    getPublicProfile(accountId: string | null | undefined): Observable<PublicProfileResponse> {
        let url_ = this.baseUrl + "/api/public/Account/profile?";
        if (accountId !== undefined && accountId !== null)
            url_ += "accountId=" + encodeURIComponent("" + accountId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPublicProfile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPublicProfile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PublicProfileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PublicProfileResponse>;
        }));
    }

    protected processGetPublicProfile(response: HttpResponseBase): Observable<PublicProfileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PublicProfileResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getCountryCode(): Observable<void> {
        let url_ = this.baseUrl + "/api/public/Account/country-code";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCountryCode(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCountryCode(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processGetCountryCode(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getCountryCodes(): Observable<Country[]> {
        let url_ = this.baseUrl + "/api/public/Account/country/all";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCountryCodes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCountryCodes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Country[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Country[]>;
        }));
    }

    protected processGetCountryCodes(response: HttpResponseBase): Observable<Country[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Country.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets the registration configuration for the specified Cognito user pool
     * @param userPoolId The Cognito User Pool ID to check registration settings for
     * @return Success
     */
    getRegistrationConfig(userPoolId: string): Observable<RegistrationConfigDto> {
        let url_ = this.baseUrl + "/api/public/Account/registration-config/{userPoolId}";
        if (userPoolId === undefined || userPoolId === null)
            throw new Error("The parameter 'userPoolId' must be defined.");
        url_ = url_.replace("{userPoolId}", encodeURIComponent("" + userPoolId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRegistrationConfig(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRegistrationConfig(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RegistrationConfigDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RegistrationConfigDto>;
        }));
    }

    protected processGetRegistrationConfig(response: HttpResponseBase): Observable<RegistrationConfigDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RegistrationConfigDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param cpf (optional) 
     * @return Success
     */
    getCpfInfo(cpf: string | null | undefined): Observable<CpfInfoResponse> {
        let url_ = this.baseUrl + "/api/public/Account/get-cpf-info?";
        if (cpf !== undefined && cpf !== null)
            url_ += "cpf=" + encodeURIComponent("" + cpf) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCpfInfo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCpfInfo(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CpfInfoResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CpfInfoResponse>;
        }));
    }

    protected processGetCpfInfo(response: HttpResponseBase): Observable<CpfInfoResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CpfInfoResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param cpf (optional) 
     * @param token (optional) 
     * @return Success
     */
    getProfileByCpf(cpf: string | null | undefined, token: string | null | undefined): Observable<PublicProfileResponse> {
        let url_ = this.baseUrl + "/api/public/Account/profile-by-cpf?";
        if (cpf !== undefined && cpf !== null)
            url_ += "cpf=" + encodeURIComponent("" + cpf) + "&";
        if (token !== undefined && token !== null)
            url_ += "token=" + encodeURIComponent("" + token) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetProfileByCpf(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProfileByCpf(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PublicProfileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PublicProfileResponse>;
        }));
    }

    protected processGetProfileByCpf(response: HttpResponseBase): Observable<PublicProfileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PublicProfileResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param brasilLoginRequest (optional) 
     * @return Success
     */
    brasilLogin(brasilLoginRequest: BrasilLoginRequest | null | undefined): Observable<ProfileResponseTokenResponseValueTuple> {
        let url_ = this.baseUrl + "/api/public/Account/brasil-login";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(brasilLoginRequest);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processBrasilLogin(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBrasilLogin(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProfileResponseTokenResponseValueTuple>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProfileResponseTokenResponseValueTuple>;
        }));
    }

    protected processBrasilLogin(response: HttpResponseBase): Observable<ProfileResponseTokenResponseValueTuple> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProfileResponseTokenResponseValueTuple.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param recoverPasswordRequest (optional) 
     * @return Success
     */
    recoverPassword(recoverPasswordRequest: RecoverPasswordRequest | null | undefined): Observable<ProfileResponseTokenResponseValueTuple> {
        let url_ = this.baseUrl + "/api/public/Account/recover-password";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(recoverPasswordRequest);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRecoverPassword(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRecoverPassword(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProfileResponseTokenResponseValueTuple>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProfileResponseTokenResponseValueTuple>;
        }));
    }

    protected processRecoverPassword(response: HttpResponseBase): Observable<ProfileResponseTokenResponseValueTuple> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProfileResponseTokenResponseValueTuple.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param cpf (optional) 
     * @param phoneNumber (optional) 
     * @return Success
     */
    checkExistedAccount(cpf: string | null | undefined, phoneNumber: string | null | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/public/Account/check-existed-account?";
        if (cpf !== undefined && cpf !== null)
            url_ += "cpf=" + encodeURIComponent("" + cpf) + "&";
        if (phoneNumber !== undefined && phoneNumber !== null)
            url_ += "phoneNumber=" + encodeURIComponent("" + phoneNumber) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCheckExistedAccount(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCheckExistedAccount(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processCheckExistedAccount(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get application user settings value by name
     * @param name Name of settings
     * @return Success
     */
    getApplicationUserSettingsByName(name: string): Observable<ApplicationUserSettings> {
        let url_ = this.baseUrl + "/api/public/Account/application-user-settings/{name}";
        if (name === undefined || name === null)
            throw new Error("The parameter 'name' must be defined.");
        url_ = url_.replace("{name}", encodeURIComponent("" + name));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetApplicationUserSettingsByName(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetApplicationUserSettingsByName(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationUserSettings>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationUserSettings>;
        }));
    }

    protected processGetApplicationUserSettingsByName(response: HttpResponseBase): Observable<ApplicationUserSettings> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApplicationUserSettings.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class RolesUMClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_USER_MANAGEMENT_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * list all existing roles
     * @return Success
     */
    getExistingRoles(): Observable<Role[]> {
        let url_ = this.baseUrl + "/api/admin/Roles/all";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetExistingRoles(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetExistingRoles(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Role[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Role[]>;
        }));
    }

    protected processGetExistingRoles(response: HttpResponseBase): Observable<Role[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Role.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * get all user roles (enabled and disabled ones)
     * @return Success
     */
    getUserRoles(accountId: string): Observable<AccountRole[]> {
        let url_ = this.baseUrl + "/api/admin/Roles/{accountId}";
        if (accountId === undefined || accountId === null)
            throw new Error("The parameter 'accountId' must be defined.");
        url_ = url_.replace("{accountId}", encodeURIComponent("" + accountId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUserRoles(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserRoles(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AccountRole[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AccountRole[]>;
        }));
    }

    protected processGetUserRoles(response: HttpResponseBase): Observable<AccountRole[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AccountRole.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * add a role to an account
     * @return Success
     */
    removeUserRole(accountId: string, roleName: string): Observable<void> {
        let url_ = this.baseUrl + "/api/admin/Roles/{accountId}/{roleName}";
        if (accountId === undefined || accountId === null)
            throw new Error("The parameter 'accountId' must be defined.");
        url_ = url_.replace("{accountId}", encodeURIComponent("" + accountId));
        if (roleName === undefined || roleName === null)
            throw new Error("The parameter 'roleName' must be defined.");
        url_ = url_.replace("{roleName}", encodeURIComponent("" + roleName));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRemoveUserRole(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRemoveUserRole(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processRemoveUserRole(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * remove a role from an account
     * @return Success
     */
    addUserRole(accountId: string, roleName: string): Observable<void> {
        let url_ = this.baseUrl + "/api/admin/Roles/{accountId}/{roleName}";
        if (accountId === undefined || accountId === null)
            throw new Error("The parameter 'accountId' must be defined.");
        url_ = url_.replace("{accountId}", encodeURIComponent("" + accountId));
        if (roleName === undefined || roleName === null)
            throw new Error("The parameter 'roleName' must be defined.");
        url_ = url_.replace("{roleName}", encodeURIComponent("" + roleName));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddUserRole(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddUserRole(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processAddUserRole(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class TestHelperUMClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_USER_MANAGEMENT_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @return Success
     */
    getPostmanTestAccountToken(): Observable<string> {
        let url_ = this.baseUrl + "/api/TestHelper/getPostmanTestAccountToken";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPostmanTestAccountToken(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPostmanTestAccountToken(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processGetPostmanTestAccountToken(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    clearTestUserData(phoneNumber: string): Observable<void> {
        let url_ = this.baseUrl + "/api/TestHelper/clearTestUserData/{phoneNumber}";
        if (phoneNumber === undefined || phoneNumber === null)
            throw new Error("The parameter 'phoneNumber' must be defined.");
        url_ = url_.replace("{phoneNumber}", encodeURIComponent("" + phoneNumber));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processClearTestUserData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processClearTestUserData(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processClearTestUserData(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param accountId (optional) 
     * @return Success
     */
    getEmailValidationCode(accountId: string | null | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/TestHelper/emailValidationCode?";
        if (accountId !== undefined && accountId !== null)
            url_ += "accountId=" + encodeURIComponent("" + accountId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEmailValidationCode(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEmailValidationCode(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processGetEmailValidationCode(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param email (optional) 
     * @return Success
     */
    getEmailRecoverCode(email: string | null | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/TestHelper/emailRecoverCode?";
        if (email !== undefined && email !== null)
            url_ += "email=" + encodeURIComponent("" + email) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEmailRecoverCode(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEmailRecoverCode(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processGetEmailRecoverCode(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class TokenUMClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_USER_MANAGEMENT_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * creates the session and phoneDevice (if new device detected) and returns token and refresh token and s
     * @param verificationId (optional) 
     * @return Success
     */
    createToken(verificationId: string | null | undefined): Observable<TokenResponse> {
        let url_ = this.baseUrl + "/api/Token?";
        if (verificationId !== undefined && verificationId !== null)
            url_ += "verificationId=" + encodeURIComponent("" + verificationId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateToken(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateToken(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TokenResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TokenResponse>;
        }));
    }

    protected processCreateToken(response: HttpResponseBase): Observable<TokenResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TokenResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * creates a new token with refreshed information (if roles changed for example) and valid
     * @param token (optional) the expired or stale token
     * @param refreshToken (optional) the previously received refreshToken (obtained along with the current token)
     * @param validationId (optional) the id of the session to be reinitialized
     * @return Success
     * @deprecated
     */
    refresh(token: string | null | undefined, refreshToken: string | null | undefined, validationId: string | null | undefined): Observable<TokenResponse> {
        let url_ = this.baseUrl + "/api/Token/refresh?";
        if (token !== undefined && token !== null)
            url_ += "token=" + encodeURIComponent("" + token) + "&";
        if (refreshToken !== undefined && refreshToken !== null)
            url_ += "refreshToken=" + encodeURIComponent("" + refreshToken) + "&";
        if (validationId !== undefined && validationId !== null)
            url_ += "validationId=" + encodeURIComponent("" + validationId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRefresh(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRefresh(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TokenResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TokenResponse>;
        }));
    }

    protected processRefresh(response: HttpResponseBase): Observable<TokenResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TokenResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Creates a new token with refreshed information (if roles changed for example) and valid
     * @param refreshTokenRequest (optional) 
     * @return Success
     */
    refreshV2(refreshTokenRequest: RefreshTokenRequest | null | undefined): Observable<TokenResponse> {
        let url_ = this.baseUrl + "/api/Token/refreshV2";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(refreshTokenRequest);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRefreshV2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRefreshV2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TokenResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TokenResponse>;
        }));
    }

    protected processRefreshV2(response: HttpResponseBase): Observable<TokenResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TokenResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Terminate session when user logout
     * @return Success
     */
    terminateSession(): Observable<void> {
        let url_ = this.baseUrl + "/api/Token/terminate-session";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTerminateSession(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTerminateSession(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processTerminateSession(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * When the mobile app detects there is phoneDeviceId or session stored in the token, 
    or the data in the actual token indicates this is a token emited by the old api (featherjs)
    then the app should exchange the old token with a new one, and in this process also register the current phone (phoneDeviceId)
     * @param token (optional) old featherjs token
     * @param phoneDeviceId (optional) some kind of unique value that does not change for a phone even if the phone is factory reset
     * @return Success
     */
    migrateOldToken(token: string | null | undefined, phoneDeviceId: string | null | undefined): Observable<TokenResponse> {
        let url_ = this.baseUrl + "/api/Token/migrate?";
        if (token !== undefined && token !== null)
            url_ += "token=" + encodeURIComponent("" + token) + "&";
        if (phoneDeviceId !== undefined && phoneDeviceId !== null)
            url_ += "phoneDeviceId=" + encodeURIComponent("" + phoneDeviceId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMigrateOldToken(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMigrateOldToken(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TokenResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TokenResponse>;
        }));
    }

    protected processMigrateOldToken(response: HttpResponseBase): Observable<TokenResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TokenResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * intended to be used by other sub-domain apis to detect if the token is stale
    the user info might change and the token (until expires) might have stale data, like an old snapshot for Roles
    This method also checks if the account or phone device has been blocked by the admin.
     * @param token (optional) current bartender app token
     */
    checkTokenValid(token: string | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/Token/checkValid?";
        if (token !== undefined && token !== null)
            url_ += "token=" + encodeURIComponent("" + token) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCheckTokenValid(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCheckTokenValid(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCheckTokenValid(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class UserConfigurationUMClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_USER_MANAGEMENT_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * Save or update a user configuration
     * @param request (optional) 
     * @return Success
     */
    save2(request: UserConfiguration | null | undefined): Observable<UserConfiguration> {
        let url_ = this.baseUrl + "/api/admin/UserConfiguration";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSave2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSave2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserConfiguration>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserConfiguration>;
        }));
    }

    protected processSave2(response: HttpResponseBase): Observable<UserConfiguration> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserConfiguration.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets the user configuration
     * @return Success
     */
    getByUserId(userId: string): Observable<UserConfiguration> {
        let url_ = this.baseUrl + "/api/admin/UserConfiguration/{userId}";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetByUserId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetByUserId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserConfiguration>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserConfiguration>;
        }));
    }

    protected processGetByUserId(response: HttpResponseBase): Observable<UserConfiguration> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserConfiguration.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class UserGroupUMClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_USER_MANAGEMENT_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @return Success
     */
    getAllUserGroups(): Observable<UserGroupInfo[]> {
        let url_ = this.baseUrl + "/api/admin/UserGroup/all";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllUserGroups(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllUserGroups(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserGroupInfo[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserGroupInfo[]>;
        }));
    }

    protected processGetAllUserGroups(response: HttpResponseBase): Observable<UserGroupInfo[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(UserGroupInfo.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Create new group
     * @param g (optional) 
     * @return Success
     */
    addUserGroup(g: AddUserGroupRequest | null | undefined): Observable<UserGroup> {
        let url_ = this.baseUrl + "/api/admin/UserGroup";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(g);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddUserGroup(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddUserGroup(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserGroup>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserGroup>;
        }));
    }

    protected processAddUserGroup(response: HttpResponseBase): Observable<UserGroup> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserGroup.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param description (optional) 
     * @return Success
     */
    updateUserGroup(groupName: string, description: string | null | undefined): Observable<UserGroup> {
        let url_ = this.baseUrl + "/api/admin/UserGroup/{groupName}?";
        if (groupName === undefined || groupName === null)
            throw new Error("The parameter 'groupName' must be defined.");
        url_ = url_.replace("{groupName}", encodeURIComponent("" + groupName));
        if (description !== undefined && description !== null)
            url_ += "description=" + encodeURIComponent("" + description) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("patch", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateUserGroup(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateUserGroup(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserGroup>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserGroup>;
        }));
    }

    protected processUpdateUserGroup(response: HttpResponseBase): Observable<UserGroup> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserGroup.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    addUserToGroup(groupName: string, accountId: string): Observable<void> {
        let url_ = this.baseUrl + "/api/admin/UserGroup/{groupName}/{accountId}";
        if (groupName === undefined || groupName === null)
            throw new Error("The parameter 'groupName' must be defined.");
        url_ = url_.replace("{groupName}", encodeURIComponent("" + groupName));
        if (accountId === undefined || accountId === null)
            throw new Error("The parameter 'accountId' must be defined.");
        url_ = url_.replace("{accountId}", encodeURIComponent("" + accountId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddUserToGroup(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddUserToGroup(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processAddUserToGroup(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    removeUserFromGroup(groupName: string, accountId: string): Observable<void> {
        let url_ = this.baseUrl + "/api/admin/UserGroup/{groupName}/{accountId}";
        if (groupName === undefined || groupName === null)
            throw new Error("The parameter 'groupName' must be defined.");
        url_ = url_.replace("{groupName}", encodeURIComponent("" + groupName));
        if (accountId === undefined || accountId === null)
            throw new Error("The parameter 'accountId' must be defined.");
        url_ = url_.replace("{accountId}", encodeURIComponent("" + accountId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRemoveUserFromGroup(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRemoveUserFromGroup(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processRemoveUserFromGroup(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getAllUserGroups2(accountId: string): Observable<string[]> {
        let url_ = this.baseUrl + "/api/admin/UserGroup/all/{accountId}";
        if (accountId === undefined || accountId === null)
            throw new Error("The parameter 'accountId' must be defined.");
        url_ = url_.replace("{accountId}", encodeURIComponent("" + accountId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllUserGroups2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllUserGroups2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string[]>;
        }));
    }

    protected processGetAllUserGroups2(response: HttpResponseBase): Observable<string[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getAllAccountsWithGroup(groupName: string): Observable<ProfileResponse[]> {
        let url_ = this.baseUrl + "/api/admin/UserGroup/{groupName}/accounts";
        if (groupName === undefined || groupName === null)
            throw new Error("The parameter 'groupName' must be defined.");
        url_ = url_.replace("{groupName}", encodeURIComponent("" + groupName));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllAccountsWithGroup(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllAccountsWithGroup(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProfileResponse[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProfileResponse[]>;
        }));
    }

    protected processGetAllAccountsWithGroup(response: HttpResponseBase): Observable<ProfileResponse[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ProfileResponse.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class UserLabelsUMClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_USER_MANAGEMENT_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @return Success
     */
    getUserLabels(accountId: string): Observable<UserLabel[]> {
        let url_ = this.baseUrl + "/api/admin/UserLabels/{accountId}";
        if (accountId === undefined || accountId === null)
            throw new Error("The parameter 'accountId' must be defined.");
        url_ = url_.replace("{accountId}", encodeURIComponent("" + accountId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUserLabels(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserLabels(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserLabel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserLabel[]>;
        }));
    }

    protected processGetUserLabels(response: HttpResponseBase): Observable<UserLabel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(UserLabel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param request (optional) 
     * @return Success
     */
    addUserLabel(request: AddUserLabelRequest | null | undefined): Observable<UserLabel> {
        let url_ = this.baseUrl + "/api/admin/UserLabels/addUserLabel";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddUserLabel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddUserLabel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserLabel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserLabel>;
        }));
    }

    protected processAddUserLabel(response: HttpResponseBase): Observable<UserLabel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserLabel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    deleteUserLabel(labelId: string): Observable<void> {
        let url_ = this.baseUrl + "/api/admin/UserLabels/deleteUserLabel/{labelId}";
        if (labelId === undefined || labelId === null)
            throw new Error("The parameter 'labelId' must be defined.");
        url_ = url_.replace("{labelId}", encodeURIComponent("" + labelId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteUserLabel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteUserLabel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteUserLabel(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class UserSessionUMClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_USER_MANAGEMENT_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * used to get user sessioninformation
     * @return Success
     */
    getUserSessionByAccountId(accountId: string): Observable<UserSession> {
        let url_ = this.baseUrl + "/api/admin/UserSession/{accountId}";
        if (accountId === undefined || accountId === null)
            throw new Error("The parameter 'accountId' must be defined.");
        url_ = url_.replace("{accountId}", encodeURIComponent("" + accountId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUserSessionByAccountId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserSessionByAccountId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserSession>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserSession>;
        }));
    }

    protected processGetUserSessionByAccountId(response: HttpResponseBase): Observable<UserSession> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserSession.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class UserTagsUMClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_USER_MANAGEMENT_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @return Success
     */
    getUserTags2(accountId: string): Observable<UserTag[]> {
        let url_ = this.baseUrl + "/api/admin/UserTags/{accountId}";
        if (accountId === undefined || accountId === null)
            throw new Error("The parameter 'accountId' must be defined.");
        url_ = url_.replace("{accountId}", encodeURIComponent("" + accountId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUserTags2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserTags2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserTag[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserTag[]>;
        }));
    }

    protected processGetUserTags2(response: HttpResponseBase): Observable<UserTag[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(UserTag.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param request (optional) 
     * @return Success
     */
    addUserTag(request: AddUserTagRequest | null | undefined): Observable<UserTag> {
        let url_ = this.baseUrl + "/api/admin/UserTags/addUserTag";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddUserTag(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddUserTag(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserTag>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserTag>;
        }));
    }

    protected processAddUserTag(response: HttpResponseBase): Observable<UserTag> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserTag.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param request (optional) 
     * @return Success
     */
    updateUserTag(request: UpdateUserTagRequest | null | undefined): Observable<UserTag> {
        let url_ = this.baseUrl + "/api/admin/UserTags/updateUserTag";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("patch", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateUserTag(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateUserTag(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserTag>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserTag>;
        }));
    }

    protected processUpdateUserTag(response: HttpResponseBase): Observable<UserTag> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserTag.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param request (optional) 
     * @return Success
     */
    upsertUserTag(request: UpsertUserTagRequest | null | undefined): Observable<UserTag> {
        let url_ = this.baseUrl + "/api/admin/UserTags/upsertUserTag";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpsertUserTag(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpsertUserTag(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserTag>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserTag>;
        }));
    }

    protected processUpsertUserTag(response: HttpResponseBase): Observable<UserTag> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserTag.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    removeUserTag(tagId: string): Observable<void> {
        let url_ = this.baseUrl + "/api/admin/UserTags/removeUserTag/{tagId}";
        if (tagId === undefined || tagId === null)
            throw new Error("The parameter 'tagId' must be defined.");
        url_ = url_.replace("{tagId}", encodeURIComponent("" + tagId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRemoveUserTag(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRemoveUserTag(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processRemoveUserTag(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param tagSearch (optional) 
     * @return Success
     */
    getTagSuggestions(tagSearch: string | null | undefined): Observable<string[]> {
        let url_ = this.baseUrl + "/api/admin/UserTags/suggestTags?";
        if (tagSearch !== undefined && tagSearch !== null)
            url_ += "tagSearch=" + encodeURIComponent("" + tagSearch) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTagSuggestions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTagSuggestions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string[]>;
        }));
    }

    protected processGetTagSuggestions(response: HttpResponseBase): Observable<string[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param tag (optional) 
     * @param valueSearch (optional) 
     * @return Success
     */
    getTagValuesSuggestions(tag: string | null | undefined, valueSearch: string | null | undefined): Observable<string[]> {
        let url_ = this.baseUrl + "/api/admin/UserTags/suggestTagValues?";
        if (tag !== undefined && tag !== null)
            url_ += "tag=" + encodeURIComponent("" + tag) + "&";
        if (valueSearch !== undefined && valueSearch !== null)
            url_ += "valueSearch=" + encodeURIComponent("" + valueSearch) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTagValuesSuggestions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTagValuesSuggestions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string[]>;
        }));
    }

    protected processGetTagValuesSuggestions(response: HttpResponseBase): Observable<string[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class VerifyPhoneUMClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_USER_MANAGEMENT_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * lists existing calling codes along with country codes and country names
    if gps coordinates are provided it will also use google api to find out the country and suggest the CurrentCountryCode
     * @param lat (optional) gps latitude
     * @param lng (optional) gps longitude
     * @return Success
     */
    getCountryCallingcodes(lat: number | null | undefined, lng: number | null | undefined): Observable<CountryCallingCodesResponse> {
        let url_ = this.baseUrl + "/api/VerifyPhone/contryCallingCodes?";
        if (lat !== undefined && lat !== null)
            url_ += "lat=" + encodeURIComponent("" + lat) + "&";
        if (lng !== undefined && lng !== null)
            url_ += "lng=" + encodeURIComponent("" + lng) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCountryCallingcodes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCountryCallingcodes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CountryCallingCodesResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CountryCallingCodesResponse>;
        }));
    }

    protected processGetCountryCallingcodes(response: HttpResponseBase): Observable<CountryCallingCodesResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CountryCallingCodesResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Use nexmo to trigger a phone verification workflow (using SMS -TTS flow (#5) 
    Can call token along with with verification id and code to authenticate
    Option to go to next step before time expires for sms and manually skip to TTS
    validate by recaptcha version 2
     * @param phoneNumber This number must be in E.164 format. https://en.wikipedia.org/wiki/E.164 and must include the calling code
     * @param callingCode (optional) Phone prefix/calling code. Will be auto-detected from the full phone number if left empty otherwise should match phone prefix.
     * @param countryCode (optional) Country of the phone number. Will be auto-detected from the full phone number if left empty. Beware, some countries share some CallingCodes, so in this case first country will be filled-in.
     * @param language SMS/TTS Nexmo language - Must be one of: ar-xa, cs-cz, cy-cy, cy-gb, da-dk, de-de, el-gr, en-au, en-gb, en-in, en-us, es-es, es-mx, es-us, fi-fi, fil-ph, fr-ca, fr-fr, hi-in, hu-hu, id-id, is-is, it-it, ja-jp, ko-kr, nb-no, nl-nl, pl-pl, pt-br, pt-pt, ro-ro, ru-ru, sv-se, tr-tr, vi-vn, zh-cn or zh-tw
     * @param phoneDeviceId the phone id
     * @param applicationId Unique application id that makes this call (e.g.: 'BartenderApp', 'HomeSafe', 'CheerTips', 'Loyalty')
     * @param recaptchaToken Google recaptcha v3 token obtained client-side
     * @param anonymousId (optional) Anonymous id of the user that is trying to verify the phone number. This is used to track the verification process and send events.
     * @param visitorId (optional) Visitor ID captured by fingerprintjs
     * @param verificationType (optional) Type of verification to use. Default is SMS, but can also be TTS.
     * @return number validation started successfully. An SMS with the validation code should be sent to the requested number. Returns the verificationId
     */
    startVerifyPhoneNumberWithRecaptchaV2(phoneNumber: string, callingCode: string | null | undefined, countryCode: string | null | undefined, language: string, phoneDeviceId: string, applicationId: string, recaptchaToken: string, anonymousId: string | null | undefined, visitorId: string | null | undefined, verificationType: any | null | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/VerifyPhone/startVerifyPhoneWithRecaptcha/v2?";
        if (phoneNumber === undefined || phoneNumber === null)
            throw new Error("The parameter 'phoneNumber' must be defined and cannot be null.");
        else
            url_ += "phoneNumber=" + encodeURIComponent("" + phoneNumber) + "&";
        if (callingCode !== undefined && callingCode !== null)
            url_ += "callingCode=" + encodeURIComponent("" + callingCode) + "&";
        if (countryCode !== undefined && countryCode !== null)
            url_ += "countryCode=" + encodeURIComponent("" + countryCode) + "&";
        if (language === undefined || language === null)
            throw new Error("The parameter 'language' must be defined and cannot be null.");
        else
            url_ += "language=" + encodeURIComponent("" + language) + "&";
        if (phoneDeviceId === undefined || phoneDeviceId === null)
            throw new Error("The parameter 'phoneDeviceId' must be defined and cannot be null.");
        else
            url_ += "phoneDeviceId=" + encodeURIComponent("" + phoneDeviceId) + "&";
        if (applicationId === undefined || applicationId === null)
            throw new Error("The parameter 'applicationId' must be defined and cannot be null.");
        else
            url_ += "applicationId=" + encodeURIComponent("" + applicationId) + "&";
        if (recaptchaToken === undefined || recaptchaToken === null)
            throw new Error("The parameter 'recaptchaToken' must be defined and cannot be null.");
        else
            url_ += "recaptchaToken=" + encodeURIComponent("" + recaptchaToken) + "&";
        if (anonymousId !== undefined && anonymousId !== null)
            url_ += "anonymousId=" + encodeURIComponent("" + anonymousId) + "&";
        if (visitorId !== undefined && visitorId !== null)
            url_ += "visitorId=" + encodeURIComponent("" + visitorId) + "&";
        if (verificationType !== undefined && verificationType !== null)
            url_ += "verificationType=" + encodeURIComponent("" + verificationType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processStartVerifyPhoneNumberWithRecaptchaV2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processStartVerifyPhoneNumberWithRecaptchaV2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processStartVerifyPhoneNumberWithRecaptchaV2(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Phone number or language is invalid (most probably). Number can also be blacklisted or network not supported by nexmo.", status, _responseText, _headers);
            }));
        } else if (status === 429) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Sms abuse detected - too many requests from the same ip detected!", status, _responseText, _headers);
            }));
        } else if (status === 406) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Another verification for this number in progress.", status, _responseText, _headers);
            }));
        } else if (status === 424) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Nexmo api call failed - credentials error.", status, _responseText, _headers);
            }));
        } else if (status === 412) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Recaptcha token invalid", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param callingCode (optional) 
     * @param countryCode (optional) 
     * @param anonymousId (optional) 
     * @param visitorId (optional) 
     * @return Success
     */
    startVerifyTTSPhoneNumberWithRecaptchaEnterprise(phoneNumber: string, callingCode: string | null | undefined, countryCode: string | null | undefined, language: string, phoneDeviceId: string, applicationId: string, recaptchaToken: string, anonymousId: string | null | undefined, visitorId: string | null | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/VerifyPhone/startVerifyTTSPhoneWithRecaptcha/enterprise?";
        if (phoneNumber === undefined || phoneNumber === null)
            throw new Error("The parameter 'phoneNumber' must be defined and cannot be null.");
        else
            url_ += "phoneNumber=" + encodeURIComponent("" + phoneNumber) + "&";
        if (callingCode !== undefined && callingCode !== null)
            url_ += "callingCode=" + encodeURIComponent("" + callingCode) + "&";
        if (countryCode !== undefined && countryCode !== null)
            url_ += "countryCode=" + encodeURIComponent("" + countryCode) + "&";
        if (language === undefined || language === null)
            throw new Error("The parameter 'language' must be defined and cannot be null.");
        else
            url_ += "language=" + encodeURIComponent("" + language) + "&";
        if (phoneDeviceId === undefined || phoneDeviceId === null)
            throw new Error("The parameter 'phoneDeviceId' must be defined and cannot be null.");
        else
            url_ += "phoneDeviceId=" + encodeURIComponent("" + phoneDeviceId) + "&";
        if (applicationId === undefined || applicationId === null)
            throw new Error("The parameter 'applicationId' must be defined and cannot be null.");
        else
            url_ += "applicationId=" + encodeURIComponent("" + applicationId) + "&";
        if (recaptchaToken === undefined || recaptchaToken === null)
            throw new Error("The parameter 'recaptchaToken' must be defined and cannot be null.");
        else
            url_ += "recaptchaToken=" + encodeURIComponent("" + recaptchaToken) + "&";
        if (anonymousId !== undefined && anonymousId !== null)
            url_ += "anonymousId=" + encodeURIComponent("" + anonymousId) + "&";
        if (visitorId !== undefined && visitorId !== null)
            url_ += "visitorId=" + encodeURIComponent("" + visitorId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processStartVerifyTTSPhoneNumberWithRecaptchaEnterprise(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processStartVerifyTTSPhoneNumberWithRecaptchaEnterprise(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processStartVerifyTTSPhoneNumberWithRecaptchaEnterprise(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param callingCode (optional) 
     * @param countryCode (optional) 
     * @param anonymousId (optional) 
     * @param visitorId (optional) 
     * @param verificationType (optional) 
     * @return Success
     */
    startVerifyPhoneNumberWithRecaptchaEnterprise(phoneNumber: string, callingCode: string | null | undefined, countryCode: string | null | undefined, language: string, phoneDeviceId: string, applicationId: string, recaptchaToken: string, anonymousId: string | null | undefined, visitorId: string | null | undefined, verificationType: any | null | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/VerifyPhone/startVerifyPhoneWithRecaptcha/enterprise?";
        if (phoneNumber === undefined || phoneNumber === null)
            throw new Error("The parameter 'phoneNumber' must be defined and cannot be null.");
        else
            url_ += "phoneNumber=" + encodeURIComponent("" + phoneNumber) + "&";
        if (callingCode !== undefined && callingCode !== null)
            url_ += "callingCode=" + encodeURIComponent("" + callingCode) + "&";
        if (countryCode !== undefined && countryCode !== null)
            url_ += "countryCode=" + encodeURIComponent("" + countryCode) + "&";
        if (language === undefined || language === null)
            throw new Error("The parameter 'language' must be defined and cannot be null.");
        else
            url_ += "language=" + encodeURIComponent("" + language) + "&";
        if (phoneDeviceId === undefined || phoneDeviceId === null)
            throw new Error("The parameter 'phoneDeviceId' must be defined and cannot be null.");
        else
            url_ += "phoneDeviceId=" + encodeURIComponent("" + phoneDeviceId) + "&";
        if (applicationId === undefined || applicationId === null)
            throw new Error("The parameter 'applicationId' must be defined and cannot be null.");
        else
            url_ += "applicationId=" + encodeURIComponent("" + applicationId) + "&";
        if (recaptchaToken === undefined || recaptchaToken === null)
            throw new Error("The parameter 'recaptchaToken' must be defined and cannot be null.");
        else
            url_ += "recaptchaToken=" + encodeURIComponent("" + recaptchaToken) + "&";
        if (anonymousId !== undefined && anonymousId !== null)
            url_ += "anonymousId=" + encodeURIComponent("" + anonymousId) + "&";
        if (visitorId !== undefined && visitorId !== null)
            url_ += "visitorId=" + encodeURIComponent("" + visitorId) + "&";
        if (verificationType !== undefined && verificationType !== null)
            url_ += "verificationType=" + encodeURIComponent("" + verificationType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processStartVerifyPhoneNumberWithRecaptchaEnterprise(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processStartVerifyPhoneNumberWithRecaptchaEnterprise(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processStartVerifyPhoneNumberWithRecaptchaEnterprise(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Cancels the phone verification session.
    Warning: there is a 30 seccond rule in nexmo that does not allow cancelling a phone verification and starting another one before 30 secconds pass.
    Normally no need to use this because if you call start verify again with the same phone number, this api will detect this and stop the previous in-progress verification.
     * @param verificationId (optional) the id of the phone verification session
     * @return Success
     */
    cancelVerifyPhoneNumber(verificationId: string | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/VerifyPhone/cancelVerifyPhone?";
        if (verificationId !== undefined && verificationId !== null)
            url_ += "verificationId=" + encodeURIComponent("" + verificationId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCancelVerifyPhoneNumber(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCancelVerifyPhoneNumber(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCancelVerifyPhoneNumber(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Use nexmo to trigger phone verification workflow next step (TTS from flow (#5) 
    go to next step before time expires for sms and manually skip to TTS
     * @param verificationId (optional) 
     * @return Success
     */
    nextStepVerifyPhoneNumber(verificationId: string | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/VerifyPhone/verifyPhoneNextStep?";
        if (verificationId !== undefined && verificationId !== null)
            url_ += "verificationId=" + encodeURIComponent("" + verificationId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processNextStepVerifyPhoneNumber(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processNextStepVerifyPhoneNumber(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processNextStepVerifyPhoneNumber(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * used to validate phone by OTPS code
    If the profile does not exist, or the application specific role does not exist call CreateBartenderProfile or CreateConsumerProfile. 
    For example, Bartender App should call CreateBartenderProfile if role 'Bartender' is missing. Otherwise call token endpoint.
     * @param validatePhoneId (optional) the id of the validation session created using StartVerifyPhoneNumber
     * @param code (optional) OTPS code received by sms (or TTS call)
     * @return Success
     */
    validatePhoneCode(validatePhoneId: string | null | undefined, code: string | null | undefined): Observable<ProfileResponse> {
        let url_ = this.baseUrl + "/api/VerifyPhone/validatePhone?";
        if (validatePhoneId !== undefined && validatePhoneId !== null)
            url_ += "validatePhoneId=" + encodeURIComponent("" + validatePhoneId) + "&";
        if (code !== undefined && code !== null)
            url_ += "code=" + encodeURIComponent("" + code) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processValidatePhoneCode(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processValidatePhoneCode(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProfileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProfileResponse>;
        }));
    }

    protected processValidatePhoneCode(response: HttpResponseBase): Observable<ProfileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProfileResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class VersionUMClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_USER_MANAGEMENT_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * Get the API version of the device management sub-domain..
     * @return Success
     */
    getVersionInfo(): Observable<string> {
        let url_ = this.baseUrl + "/api/Version";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetVersionInfo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetVersionInfo(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processGetVersionInfo(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Helper method used to test exception handling.
     * @return Success
     */
    testException(): Observable<string> {
        let url_ = this.baseUrl + "/api/Version/exception";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTestException(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTestException(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processTestException(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get the current country (code)
     * @return Success
     */
    currentCountry(): Observable<void> {
        let url_ = this.baseUrl + "/country";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCurrentCountry(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCurrentCountry(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCurrentCountry(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export class AccountDeviceSessionsResponse implements IAccountDeviceSessionsResponse {
    phone?: PhoneDevice | null;
    sessions?: UserSession[] | null;

    constructor(data?: IAccountDeviceSessionsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.phone = _data["phone"] ? PhoneDevice.fromJS(_data["phone"]) : <any>null;
            if (Array.isArray(_data["sessions"])) {
                this.sessions = [] as any;
                for (let item of _data["sessions"])
                    this.sessions!.push(UserSession.fromJS(item));
            }
            else {
                this.sessions = <any>null;
            }
        }
    }

    static fromJS(data: any): AccountDeviceSessionsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new AccountDeviceSessionsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["phone"] = this.phone ? this.phone.toJSON() : <any>null;
        if (Array.isArray(this.sessions)) {
            data["sessions"] = [];
            for (let item of this.sessions)
                data["sessions"].push(item.toJSON());
        }
        return data;
    }
}

export interface IAccountDeviceSessionsResponse {
    phone?: PhoneDevice | null;
    sessions?: UserSession[] | null;
}

export class AccountRole implements IAccountRole {
    accountId?: string | null;
    roleName?: string | null;

    constructor(data?: IAccountRole) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accountId = _data["accountId"] !== undefined ? _data["accountId"] : <any>null;
            this.roleName = _data["roleName"] !== undefined ? _data["roleName"] : <any>null;
        }
    }

    static fromJS(data: any): AccountRole {
        data = typeof data === 'object' ? data : {};
        let result = new AccountRole();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accountId"] = this.accountId !== undefined ? this.accountId : <any>null;
        data["roleName"] = this.roleName !== undefined ? this.roleName : <any>null;
        return data;
    }
}

export interface IAccountRole {
    accountId?: string | null;
    roleName?: string | null;
}

export enum AccountStatus {
    Active = "Active",
    Locked = "Locked",
    Deleted = "Deleted",
    Archived = "Archived",
}

export class AddUserGroupRequest implements IAddUserGroupRequest {
    name!: string;
    description?: string | null;

    constructor(data?: IAddUserGroupRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.description = _data["description"] !== undefined ? _data["description"] : <any>null;
        }
    }

    static fromJS(data: any): AddUserGroupRequest {
        data = typeof data === 'object' ? data : {};
        let result = new AddUserGroupRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["description"] = this.description !== undefined ? this.description : <any>null;
        return data;
    }
}

export interface IAddUserGroupRequest {
    name: string;
    description?: string | null;
}

export class AddUserLabelRequest implements IAddUserLabelRequest {
    accountId?: string | null;
    label?: string | null;

    constructor(data?: IAddUserLabelRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accountId = _data["accountId"] !== undefined ? _data["accountId"] : <any>null;
            this.label = _data["label"] !== undefined ? _data["label"] : <any>null;
        }
    }

    static fromJS(data: any): AddUserLabelRequest {
        data = typeof data === 'object' ? data : {};
        let result = new AddUserLabelRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accountId"] = this.accountId !== undefined ? this.accountId : <any>null;
        data["label"] = this.label !== undefined ? this.label : <any>null;
        return data;
    }
}

export interface IAddUserLabelRequest {
    accountId?: string | null;
    label?: string | null;
}

export class AddUserTagRequest implements IAddUserTagRequest {
    accountId?: string | null;
    tag?: string | null;
    value?: string | null;

    constructor(data?: IAddUserTagRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accountId = _data["accountId"] !== undefined ? _data["accountId"] : <any>null;
            this.tag = _data["tag"] !== undefined ? _data["tag"] : <any>null;
            this.value = _data["value"] !== undefined ? _data["value"] : <any>null;
        }
    }

    static fromJS(data: any): AddUserTagRequest {
        data = typeof data === 'object' ? data : {};
        let result = new AddUserTagRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accountId"] = this.accountId !== undefined ? this.accountId : <any>null;
        data["tag"] = this.tag !== undefined ? this.tag : <any>null;
        data["value"] = this.value !== undefined ? this.value : <any>null;
        return data;
    }
}

export interface IAddUserTagRequest {
    accountId?: string | null;
    tag?: string | null;
    value?: string | null;
}

export class AdminUpdateProfileRequest implements IAdminUpdateProfileRequest {
    accountId?: string | null;
    country?: string | null;
    firstName?: string | null;
    lastName?: string | null;
    phoneNumber?: string | null;
    email?: string | null;
    dob?: Date | null;
    gender?: string | null;

    constructor(data?: IAdminUpdateProfileRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accountId = _data["accountId"] !== undefined ? _data["accountId"] : <any>null;
            this.country = _data["country"] !== undefined ? _data["country"] : <any>null;
            this.firstName = _data["firstName"] !== undefined ? _data["firstName"] : <any>null;
            this.lastName = _data["lastName"] !== undefined ? _data["lastName"] : <any>null;
            this.phoneNumber = _data["phoneNumber"] !== undefined ? _data["phoneNumber"] : <any>null;
            this.email = _data["email"] !== undefined ? _data["email"] : <any>null;
            this.dob = _data["dob"] ? new Date(_data["dob"].toString()) : <any>null;
            this.gender = _data["gender"] !== undefined ? _data["gender"] : <any>null;
        }
    }

    static fromJS(data: any): AdminUpdateProfileRequest {
        data = typeof data === 'object' ? data : {};
        let result = new AdminUpdateProfileRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accountId"] = this.accountId !== undefined ? this.accountId : <any>null;
        data["country"] = this.country !== undefined ? this.country : <any>null;
        data["firstName"] = this.firstName !== undefined ? this.firstName : <any>null;
        data["lastName"] = this.lastName !== undefined ? this.lastName : <any>null;
        data["phoneNumber"] = this.phoneNumber !== undefined ? this.phoneNumber : <any>null;
        data["email"] = this.email !== undefined ? this.email : <any>null;
        data["dob"] = this.dob ? this.dob.toISOString() : <any>null;
        data["gender"] = this.gender !== undefined ? this.gender : <any>null;
        return data;
    }
}

export interface IAdminUpdateProfileRequest {
    accountId?: string | null;
    country?: string | null;
    firstName?: string | null;
    lastName?: string | null;
    phoneNumber?: string | null;
    email?: string | null;
    dob?: Date | null;
    gender?: string | null;
}

export class AdvertiserWhiteList implements IAdvertiserWhiteList {
    apiKey?: string | null;
    apiSecret?: string | null;
    name?: string | null;
    id?: string | null;
    createdAt?: Date | null;
    updatedAt?: Date | null;

    constructor(data?: IAdvertiserWhiteList) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.apiKey = _data["apiKey"] !== undefined ? _data["apiKey"] : <any>null;
            this.apiSecret = _data["apiSecret"] !== undefined ? _data["apiSecret"] : <any>null;
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : <any>null;
            this.updatedAt = _data["updatedAt"] ? new Date(_data["updatedAt"].toString()) : <any>null;
        }
    }

    static fromJS(data: any): AdvertiserWhiteList {
        data = typeof data === 'object' ? data : {};
        let result = new AdvertiserWhiteList();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["apiKey"] = this.apiKey !== undefined ? this.apiKey : <any>null;
        data["apiSecret"] = this.apiSecret !== undefined ? this.apiSecret : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : <any>null;
        data["updatedAt"] = this.updatedAt ? this.updatedAt.toISOString() : <any>null;
        return data;
    }
}

export interface IAdvertiserWhiteList {
    apiKey?: string | null;
    apiSecret?: string | null;
    name?: string | null;
    id?: string | null;
    createdAt?: Date | null;
    updatedAt?: Date | null;
}

export class ApplicationUserSettings implements IApplicationUserSettings {
    /** Name */
    name?: string | null;
    /** Value */
    value?: string | null;
    id?: string | null;
    createdAt?: Date | null;
    updatedAt?: Date | null;

    constructor(data?: IApplicationUserSettings) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.value = _data["value"] !== undefined ? _data["value"] : <any>null;
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : <any>null;
            this.updatedAt = _data["updatedAt"] ? new Date(_data["updatedAt"].toString()) : <any>null;
        }
    }

    static fromJS(data: any): ApplicationUserSettings {
        data = typeof data === 'object' ? data : {};
        let result = new ApplicationUserSettings();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["value"] = this.value !== undefined ? this.value : <any>null;
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : <any>null;
        data["updatedAt"] = this.updatedAt ? this.updatedAt.toISOString() : <any>null;
        return data;
    }
}

export interface IApplicationUserSettings {
    /** Name */
    name?: string | null;
    /** Value */
    value?: string | null;
    id?: string | null;
    createdAt?: Date | null;
    updatedAt?: Date | null;
}

export class AppVersion implements IAppVersion {
    major?: number | null;
    minor?: number | null;
    patch?: number | null;

    constructor(data?: IAppVersion) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.major = _data["major"] !== undefined ? _data["major"] : <any>null;
            this.minor = _data["minor"] !== undefined ? _data["minor"] : <any>null;
            this.patch = _data["patch"] !== undefined ? _data["patch"] : <any>null;
        }
    }

    static fromJS(data: any): AppVersion {
        data = typeof data === 'object' ? data : {};
        let result = new AppVersion();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["major"] = this.major !== undefined ? this.major : <any>null;
        data["minor"] = this.minor !== undefined ? this.minor : <any>null;
        data["patch"] = this.patch !== undefined ? this.patch : <any>null;
        return data;
    }
}

export interface IAppVersion {
    major?: number | null;
    minor?: number | null;
    patch?: number | null;
}

/** Authorization delete request model */
export class AuthorizationDeleteRequest implements IAuthorizationDeleteRequest {
    /** Id */
    id?: string | null;

    constructor(data?: IAuthorizationDeleteRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
        }
    }

    static fromJS(data: any): AuthorizationDeleteRequest {
        data = typeof data === 'object' ? data : {};
        let result = new AuthorizationDeleteRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        return data;
    }
}

/** Authorization delete request model */
export interface IAuthorizationDeleteRequest {
    /** Id */
    id?: string | null;
}

export class BartenderAppRule implements IBartenderAppRule {
    appName?: string | null;
    operatingSystem?: MobileOS | null;
    osVersion?: string | null;
    phoneModel?: string | null;
    minVersion?: AppVersion | null;
    id?: string | null;
    createdAt?: Date | null;
    updatedAt?: Date | null;

    constructor(data?: IBartenderAppRule) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.appName = _data["appName"] !== undefined ? _data["appName"] : <any>null;
            this.operatingSystem = _data["operatingSystem"] !== undefined ? _data["operatingSystem"] : <any>null;
            this.osVersion = _data["osVersion"] !== undefined ? _data["osVersion"] : <any>null;
            this.phoneModel = _data["phoneModel"] !== undefined ? _data["phoneModel"] : <any>null;
            this.minVersion = _data["minVersion"] ? AppVersion.fromJS(_data["minVersion"]) : <any>null;
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : <any>null;
            this.updatedAt = _data["updatedAt"] ? new Date(_data["updatedAt"].toString()) : <any>null;
        }
    }

    static fromJS(data: any): BartenderAppRule {
        data = typeof data === 'object' ? data : {};
        let result = new BartenderAppRule();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["appName"] = this.appName !== undefined ? this.appName : <any>null;
        data["operatingSystem"] = this.operatingSystem !== undefined ? this.operatingSystem : <any>null;
        data["osVersion"] = this.osVersion !== undefined ? this.osVersion : <any>null;
        data["phoneModel"] = this.phoneModel !== undefined ? this.phoneModel : <any>null;
        data["minVersion"] = this.minVersion ? this.minVersion.toJSON() : <any>null;
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : <any>null;
        data["updatedAt"] = this.updatedAt ? this.updatedAt.toISOString() : <any>null;
        return data;
    }
}

export interface IBartenderAppRule {
    appName?: string | null;
    operatingSystem?: MobileOS | null;
    osVersion?: string | null;
    phoneModel?: string | null;
    minVersion?: AppVersion | null;
    id?: string | null;
    createdAt?: Date | null;
    updatedAt?: Date | null;
}

/** Brand consent model */
export class BrandConsent implements IBrandConsent {
    /** Brand */
    brand?: string | null;
    /** Possible values: OptIn, OptOut */
    marketingConsent?: string | null;

    constructor(data?: IBrandConsent) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.brand = _data["brand"] !== undefined ? _data["brand"] : <any>null;
            this.marketingConsent = _data["marketingConsent"] !== undefined ? _data["marketingConsent"] : <any>null;
        }
    }

    static fromJS(data: any): BrandConsent {
        data = typeof data === 'object' ? data : {};
        let result = new BrandConsent();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["brand"] = this.brand !== undefined ? this.brand : <any>null;
        data["marketingConsent"] = this.marketingConsent !== undefined ? this.marketingConsent : <any>null;
        return data;
    }
}

/** Brand consent model */
export interface IBrandConsent {
    /** Brand */
    brand?: string | null;
    /** Possible values: OptIn, OptOut */
    marketingConsent?: string | null;
}

export class BrasilLoginRequest implements IBrasilLoginRequest {
    cpf!: string;
    password!: string;
    deviceId!: string;
    applicationId!: string;

    constructor(data?: IBrasilLoginRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.cpf = _data["cpf"] !== undefined ? _data["cpf"] : <any>null;
            this.password = _data["password"] !== undefined ? _data["password"] : <any>null;
            this.deviceId = _data["deviceId"] !== undefined ? _data["deviceId"] : <any>null;
            this.applicationId = _data["applicationId"] !== undefined ? _data["applicationId"] : <any>null;
        }
    }

    static fromJS(data: any): BrasilLoginRequest {
        data = typeof data === 'object' ? data : {};
        let result = new BrasilLoginRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["cpf"] = this.cpf !== undefined ? this.cpf : <any>null;
        data["password"] = this.password !== undefined ? this.password : <any>null;
        data["deviceId"] = this.deviceId !== undefined ? this.deviceId : <any>null;
        data["applicationId"] = this.applicationId !== undefined ? this.applicationId : <any>null;
        return data;
    }
}

export interface IBrasilLoginRequest {
    cpf: string;
    password: string;
    deviceId: string;
    applicationId: string;
}

export class ChangeEmailRequest implements IChangeEmailRequest {
    email!: string;
    language?: string | null;

    constructor(data?: IChangeEmailRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.email = _data["email"] !== undefined ? _data["email"] : <any>null;
            this.language = _data["language"] !== undefined ? _data["language"] : <any>null;
        }
    }

    static fromJS(data: any): ChangeEmailRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ChangeEmailRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["email"] = this.email !== undefined ? this.email : <any>null;
        data["language"] = this.language !== undefined ? this.language : <any>null;
        return data;
    }
}

export interface IChangeEmailRequest {
    email: string;
    language?: string | null;
}

export class ChangePhoneRequest implements IChangePhoneRequest {
    newPhoneNumber!: string;
    language?: string | null;

    constructor(data?: IChangePhoneRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.newPhoneNumber = _data["newPhoneNumber"] !== undefined ? _data["newPhoneNumber"] : <any>null;
            this.language = _data["language"] !== undefined ? _data["language"] : <any>null;
        }
    }

    static fromJS(data: any): ChangePhoneRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ChangePhoneRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["newPhoneNumber"] = this.newPhoneNumber !== undefined ? this.newPhoneNumber : <any>null;
        data["language"] = this.language !== undefined ? this.language : <any>null;
        return data;
    }
}

export interface IChangePhoneRequest {
    newPhoneNumber: string;
    language?: string | null;
}

export class ChangePhoneResponse implements IChangePhoneResponse {
    changePhoneId!: string;

    constructor(data?: IChangePhoneResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.changePhoneId = _data["changePhoneId"] !== undefined ? _data["changePhoneId"] : <any>null;
        }
    }

    static fromJS(data: any): ChangePhoneResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ChangePhoneResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["changePhoneId"] = this.changePhoneId !== undefined ? this.changePhoneId : <any>null;
        return data;
    }
}

export interface IChangePhoneResponse {
    changePhoneId: string;
}

export class ChangePhoneValidateRequest implements IChangePhoneValidateRequest {
    newPhoneNumber!: string;
    changePhoneId!: string;
    validationCode!: string;

    constructor(data?: IChangePhoneValidateRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.newPhoneNumber = _data["newPhoneNumber"] !== undefined ? _data["newPhoneNumber"] : <any>null;
            this.changePhoneId = _data["changePhoneId"] !== undefined ? _data["changePhoneId"] : <any>null;
            this.validationCode = _data["validationCode"] !== undefined ? _data["validationCode"] : <any>null;
        }
    }

    static fromJS(data: any): ChangePhoneValidateRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ChangePhoneValidateRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["newPhoneNumber"] = this.newPhoneNumber !== undefined ? this.newPhoneNumber : <any>null;
        data["changePhoneId"] = this.changePhoneId !== undefined ? this.changePhoneId : <any>null;
        data["validationCode"] = this.validationCode !== undefined ? this.validationCode : <any>null;
        return data;
    }
}

export interface IChangePhoneValidateRequest {
    newPhoneNumber: string;
    changePhoneId: string;
    validationCode: string;
}

export class ChangeSubscriptionChannelStatusRequest implements IChangeSubscriptionChannelStatusRequest {
    channel?: NotificationChannel | null;
    status?: SubscriptionStatus | null;
    value?: string | null;
    reasons?: string | null;

    constructor(data?: IChangeSubscriptionChannelStatusRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.channel = _data["channel"] !== undefined ? _data["channel"] : <any>null;
            this.status = _data["status"] !== undefined ? _data["status"] : <any>null;
            this.value = _data["value"] !== undefined ? _data["value"] : <any>null;
            this.reasons = _data["reasons"] !== undefined ? _data["reasons"] : <any>null;
        }
    }

    static fromJS(data: any): ChangeSubscriptionChannelStatusRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ChangeSubscriptionChannelStatusRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["channel"] = this.channel !== undefined ? this.channel : <any>null;
        data["status"] = this.status !== undefined ? this.status : <any>null;
        data["value"] = this.value !== undefined ? this.value : <any>null;
        data["reasons"] = this.reasons !== undefined ? this.reasons : <any>null;
        return data;
    }
}

export interface IChangeSubscriptionChannelStatusRequest {
    channel?: NotificationChannel | null;
    status?: SubscriptionStatus | null;
    value?: string | null;
    reasons?: string | null;
}

export class ChangeTermAndConditionsUrlRequest implements IChangeTermAndConditionsUrlRequest {
    termAndConditionsUrl?: string | null;

    constructor(data?: IChangeTermAndConditionsUrlRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.termAndConditionsUrl = _data["termAndConditionsUrl"] !== undefined ? _data["termAndConditionsUrl"] : <any>null;
        }
    }

    static fromJS(data: any): ChangeTermAndConditionsUrlRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ChangeTermAndConditionsUrlRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["termAndConditionsUrl"] = this.termAndConditionsUrl !== undefined ? this.termAndConditionsUrl : <any>null;
        return data;
    }
}

export interface IChangeTermAndConditionsUrlRequest {
    termAndConditionsUrl?: string | null;
}

/** Channel consent model */
export class ChannelConsent implements IChannelConsent {
    /** Email brand consent list */
    email?: BrandConsent[] | null;
    /** SMS brand consent list */
    sms?: BrandConsent[] | null;
    /** Post brand consent list */
    post?: BrandConsent[] | null;
    /** Phone brand consent list */
    phone?: BrandConsent[] | null;
    /** Paid media brand consent list */
    paidMedia?: BrandConsent[] | null;

    constructor(data?: IChannelConsent) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["email"])) {
                this.email = [] as any;
                for (let item of _data["email"])
                    this.email!.push(BrandConsent.fromJS(item));
            }
            else {
                this.email = <any>null;
            }
            if (Array.isArray(_data["sms"])) {
                this.sms = [] as any;
                for (let item of _data["sms"])
                    this.sms!.push(BrandConsent.fromJS(item));
            }
            else {
                this.sms = <any>null;
            }
            if (Array.isArray(_data["post"])) {
                this.post = [] as any;
                for (let item of _data["post"])
                    this.post!.push(BrandConsent.fromJS(item));
            }
            else {
                this.post = <any>null;
            }
            if (Array.isArray(_data["phone"])) {
                this.phone = [] as any;
                for (let item of _data["phone"])
                    this.phone!.push(BrandConsent.fromJS(item));
            }
            else {
                this.phone = <any>null;
            }
            if (Array.isArray(_data["paidMedia"])) {
                this.paidMedia = [] as any;
                for (let item of _data["paidMedia"])
                    this.paidMedia!.push(BrandConsent.fromJS(item));
            }
            else {
                this.paidMedia = <any>null;
            }
        }
    }

    static fromJS(data: any): ChannelConsent {
        data = typeof data === 'object' ? data : {};
        let result = new ChannelConsent();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.email)) {
            data["email"] = [];
            for (let item of this.email)
                data["email"].push(item.toJSON());
        }
        if (Array.isArray(this.sms)) {
            data["sms"] = [];
            for (let item of this.sms)
                data["sms"].push(item.toJSON());
        }
        if (Array.isArray(this.post)) {
            data["post"] = [];
            for (let item of this.post)
                data["post"].push(item.toJSON());
        }
        if (Array.isArray(this.phone)) {
            data["phone"] = [];
            for (let item of this.phone)
                data["phone"].push(item.toJSON());
        }
        if (Array.isArray(this.paidMedia)) {
            data["paidMedia"] = [];
            for (let item of this.paidMedia)
                data["paidMedia"].push(item.toJSON());
        }
        return data;
    }
}

/** Channel consent model */
export interface IChannelConsent {
    /** Email brand consent list */
    email?: BrandConsent[] | null;
    /** SMS brand consent list */
    sms?: BrandConsent[] | null;
    /** Post brand consent list */
    post?: BrandConsent[] | null;
    /** Phone brand consent list */
    phone?: BrandConsent[] | null;
    /** Paid media brand consent list */
    paidMedia?: BrandConsent[] | null;
}

export class CheckMinVersionRequest implements ICheckMinVersionRequest {
    operatingSystem!: MobileOS;
    osVersion?: string | null;
    phoneModel?: string | null;
    currentVersion!: AppVersion;
    appName?: string | null;

    constructor(data?: ICheckMinVersionRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.currentVersion = new AppVersion();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.operatingSystem = _data["operatingSystem"] !== undefined ? _data["operatingSystem"] : <any>null;
            this.osVersion = _data["osVersion"] !== undefined ? _data["osVersion"] : <any>null;
            this.phoneModel = _data["phoneModel"] !== undefined ? _data["phoneModel"] : <any>null;
            this.currentVersion = _data["currentVersion"] ? AppVersion.fromJS(_data["currentVersion"]) : new AppVersion();
            this.appName = _data["appName"] !== undefined ? _data["appName"] : <any>null;
        }
    }

    static fromJS(data: any): CheckMinVersionRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CheckMinVersionRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["operatingSystem"] = this.operatingSystem !== undefined ? this.operatingSystem : <any>null;
        data["osVersion"] = this.osVersion !== undefined ? this.osVersion : <any>null;
        data["phoneModel"] = this.phoneModel !== undefined ? this.phoneModel : <any>null;
        data["currentVersion"] = this.currentVersion ? this.currentVersion.toJSON() : <any>null;
        data["appName"] = this.appName !== undefined ? this.appName : <any>null;
        return data;
    }
}

export interface ICheckMinVersionRequest {
    operatingSystem: MobileOS;
    osVersion?: string | null;
    phoneModel?: string | null;
    currentVersion: AppVersion;
    appName?: string | null;
}

export class CheckMinVersionResponse implements ICheckMinVersionResponse {
    isUpdateMandatory?: boolean | null;

    constructor(data?: ICheckMinVersionResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isUpdateMandatory = _data["isUpdateMandatory"] !== undefined ? _data["isUpdateMandatory"] : <any>null;
        }
    }

    static fromJS(data: any): CheckMinVersionResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CheckMinVersionResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isUpdateMandatory"] = this.isUpdateMandatory !== undefined ? this.isUpdateMandatory : <any>null;
        return data;
    }
}

export interface ICheckMinVersionResponse {
    isUpdateMandatory?: boolean | null;
}

export class ConfigItem implements IConfigItem {
    name?: string | null;
    value?: any | null;

    constructor(data?: IConfigItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.value = _data["value"] !== undefined ? _data["value"] : <any>null;
        }
    }

    static fromJS(data: any): ConfigItem {
        data = typeof data === 'object' ? data : {};
        let result = new ConfigItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["value"] = this.value !== undefined ? this.value : <any>null;
        return data;
    }
}

export interface IConfigItem {
    name?: string | null;
    value?: any | null;
}

export class Country implements ICountry {
    readonly commonName?: string | null;
    readonly officialName?: string | null;
    readonly tld?: string[] | null;
    countryCode?: CountryCode | null;
    readonly isoNumeric?: string | null;
    isO3?: CountryCodeISO3 | null;
    readonly cioc?: string | null;
    readonly currencies?: string[] | null;
    readonly callingCodes?: string[] | null;
    readonly capital?: string | null;
    readonly alternativeSpellings?: string[] | null;
    readonly region?: string | null;
    readonly subRegion?: string | null;
    readonly borders?: CountryCodeISO3[] | null;
    readonly landlocked?: boolean | null;
    readonly area?: number | null;

    constructor(data?: ICountry) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).commonName = _data["commonName"] !== undefined ? _data["commonName"] : <any>null;
            (<any>this).officialName = _data["officialName"] !== undefined ? _data["officialName"] : <any>null;
            if (Array.isArray(_data["tld"])) {
                (<any>this).tld = [] as any;
                for (let item of _data["tld"])
                    (<any>this).tld!.push(item);
            }
            else {
                (<any>this).tld = <any>null;
            }
            this.countryCode = _data["countryCode"] !== undefined ? _data["countryCode"] : <any>null;
            (<any>this).isoNumeric = _data["isoNumeric"] !== undefined ? _data["isoNumeric"] : <any>null;
            this.isO3 = _data["isO3"] !== undefined ? _data["isO3"] : <any>null;
            (<any>this).cioc = _data["cioc"] !== undefined ? _data["cioc"] : <any>null;
            if (Array.isArray(_data["currencies"])) {
                (<any>this).currencies = [] as any;
                for (let item of _data["currencies"])
                    (<any>this).currencies!.push(item);
            }
            else {
                (<any>this).currencies = <any>null;
            }
            if (Array.isArray(_data["callingCodes"])) {
                (<any>this).callingCodes = [] as any;
                for (let item of _data["callingCodes"])
                    (<any>this).callingCodes!.push(item);
            }
            else {
                (<any>this).callingCodes = <any>null;
            }
            (<any>this).capital = _data["capital"] !== undefined ? _data["capital"] : <any>null;
            if (Array.isArray(_data["alternativeSpellings"])) {
                (<any>this).alternativeSpellings = [] as any;
                for (let item of _data["alternativeSpellings"])
                    (<any>this).alternativeSpellings!.push(item);
            }
            else {
                (<any>this).alternativeSpellings = <any>null;
            }
            (<any>this).region = _data["region"] !== undefined ? _data["region"] : <any>null;
            (<any>this).subRegion = _data["subRegion"] !== undefined ? _data["subRegion"] : <any>null;
            if (Array.isArray(_data["borders"])) {
                (<any>this).borders = [] as any;
                for (let item of _data["borders"])
                    (<any>this).borders!.push(item);
            }
            else {
                (<any>this).borders = <any>null;
            }
            (<any>this).landlocked = _data["landlocked"] !== undefined ? _data["landlocked"] : <any>null;
            (<any>this).area = _data["area"] !== undefined ? _data["area"] : <any>null;
        }
    }

    static fromJS(data: any): Country {
        data = typeof data === 'object' ? data : {};
        let result = new Country();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["commonName"] = this.commonName !== undefined ? this.commonName : <any>null;
        data["officialName"] = this.officialName !== undefined ? this.officialName : <any>null;
        if (Array.isArray(this.tld)) {
            data["tld"] = [];
            for (let item of this.tld)
                data["tld"].push(item);
        }
        data["countryCode"] = this.countryCode !== undefined ? this.countryCode : <any>null;
        data["isoNumeric"] = this.isoNumeric !== undefined ? this.isoNumeric : <any>null;
        data["isO3"] = this.isO3 !== undefined ? this.isO3 : <any>null;
        data["cioc"] = this.cioc !== undefined ? this.cioc : <any>null;
        if (Array.isArray(this.currencies)) {
            data["currencies"] = [];
            for (let item of this.currencies)
                data["currencies"].push(item);
        }
        if (Array.isArray(this.callingCodes)) {
            data["callingCodes"] = [];
            for (let item of this.callingCodes)
                data["callingCodes"].push(item);
        }
        data["capital"] = this.capital !== undefined ? this.capital : <any>null;
        if (Array.isArray(this.alternativeSpellings)) {
            data["alternativeSpellings"] = [];
            for (let item of this.alternativeSpellings)
                data["alternativeSpellings"].push(item);
        }
        data["region"] = this.region !== undefined ? this.region : <any>null;
        data["subRegion"] = this.subRegion !== undefined ? this.subRegion : <any>null;
        if (Array.isArray(this.borders)) {
            data["borders"] = [];
            for (let item of this.borders)
                data["borders"].push(item);
        }
        data["landlocked"] = this.landlocked !== undefined ? this.landlocked : <any>null;
        data["area"] = this.area !== undefined ? this.area : <any>null;
        return data;
    }
}

export interface ICountry {
    commonName?: string | null;
    officialName?: string | null;
    tld?: string[] | null;
    countryCode?: CountryCode | null;
    isoNumeric?: string | null;
    isO3?: CountryCodeISO3 | null;
    cioc?: string | null;
    currencies?: string[] | null;
    callingCodes?: string[] | null;
    capital?: string | null;
    alternativeSpellings?: string[] | null;
    region?: string | null;
    subRegion?: string | null;
    borders?: CountryCodeISO3[] | null;
    landlocked?: boolean | null;
    area?: number | null;
}

export class CountryCallingCode implements ICountryCallingCode {
    countryCode?: string | null;
    callingCode?: string | null;
    countryName?: string | null;

    constructor(data?: ICountryCallingCode) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.countryCode = _data["countryCode"] !== undefined ? _data["countryCode"] : <any>null;
            this.callingCode = _data["callingCode"] !== undefined ? _data["callingCode"] : <any>null;
            this.countryName = _data["countryName"] !== undefined ? _data["countryName"] : <any>null;
        }
    }

    static fromJS(data: any): CountryCallingCode {
        data = typeof data === 'object' ? data : {};
        let result = new CountryCallingCode();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["countryCode"] = this.countryCode !== undefined ? this.countryCode : <any>null;
        data["callingCode"] = this.callingCode !== undefined ? this.callingCode : <any>null;
        data["countryName"] = this.countryName !== undefined ? this.countryName : <any>null;
        return data;
    }
}

export interface ICountryCallingCode {
    countryCode?: string | null;
    callingCode?: string | null;
    countryName?: string | null;
}

export class CountryCallingCodesResponse implements ICountryCallingCodesResponse {
    /** current country code of the user if user location (lat/lng coodinates) are provided. otherwise empty */
    currentCountryCode?: string | null;
    /** all existing calling codes along with country codes and country names
beware: some countries share some calling codes (e.g. canada/usa => calling code 1) */
    allCodes?: CountryCallingCode[] | null;

    constructor(data?: ICountryCallingCodesResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.currentCountryCode = _data["currentCountryCode"] !== undefined ? _data["currentCountryCode"] : <any>null;
            if (Array.isArray(_data["allCodes"])) {
                this.allCodes = [] as any;
                for (let item of _data["allCodes"])
                    this.allCodes!.push(CountryCallingCode.fromJS(item));
            }
            else {
                this.allCodes = <any>null;
            }
        }
    }

    static fromJS(data: any): CountryCallingCodesResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CountryCallingCodesResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["currentCountryCode"] = this.currentCountryCode !== undefined ? this.currentCountryCode : <any>null;
        if (Array.isArray(this.allCodes)) {
            data["allCodes"] = [];
            for (let item of this.allCodes)
                data["allCodes"].push(item.toJSON());
        }
        return data;
    }
}

export interface ICountryCallingCodesResponse {
    /** current country code of the user if user location (lat/lng coodinates) are provided. otherwise empty */
    currentCountryCode?: string | null;
    /** all existing calling codes along with country codes and country names
beware: some countries share some calling codes (e.g. canada/usa => calling code 1) */
    allCodes?: CountryCallingCode[] | null;
}

export enum CountryCode {
    World = "World",
    AW = "AW",
    AF = "AF",
    AO = "AO",
    AI = "AI",
    AX = "AX",
    AL = "AL",
    AD = "AD",
    AE = "AE",
    AR = "AR",
    AM = "AM",
    AS = "AS",
    AQ = "AQ",
    TF = "TF",
    AG = "AG",
    AU = "AU",
    AT = "AT",
    AZ = "AZ",
    BI = "BI",
    BE = "BE",
    BJ = "BJ",
    BF = "BF",
    BD = "BD",
    BG = "BG",
    BH = "BH",
    BS = "BS",
    BA = "BA",
    BL = "BL",
    BY = "BY",
    BZ = "BZ",
    BM = "BM",
    BO = "BO",
    BR = "BR",
    BB = "BB",
    BN = "BN",
    BT = "BT",
    BV = "BV",
    BW = "BW",
    CF = "CF",
    CA = "CA",
    CC = "CC",
    CH = "CH",
    CL = "CL",
    CN = "CN",
    CI = "CI",
    CM = "CM",
    CD = "CD",
    CG = "CG",
    CK = "CK",
    CO = "CO",
    KM = "KM",
    CV = "CV",
    CR = "CR",
    CU = "CU",
    CW = "CW",
    CX = "CX",
    KY = "KY",
    CY = "CY",
    CZ = "CZ",
    DE = "DE",
    DJ = "DJ",
    DM = "DM",
    DK = "DK",
    DO = "DO",
    DZ = "DZ",
    EC = "EC",
    EG = "EG",
    ER = "ER",
    EH = "EH",
    ES = "ES",
    EE = "EE",
    ET = "ET",
    FI = "FI",
    FJ = "FJ",
    FK = "FK",
    FR = "FR",
    FO = "FO",
    FM = "FM",
    GA = "GA",
    UK = "UK",
    GE = "GE",
    GG = "GG",
    GH = "GH",
    GI = "GI",
    GN = "GN",
    GP = "GP",
    GM = "GM",
    GW = "GW",
    GQ = "GQ",
    GR = "GR",
    GD = "GD",
    GL = "GL",
    GT = "GT",
    GF = "GF",
    GU = "GU",
    GY = "GY",
    HK = "HK",
    HM = "HM",
    HN = "HN",
    HR = "HR",
    HT = "HT",
    HU = "HU",
    ID = "ID",
    IM = "IM",
    IN = "IN",
    IO = "IO",
    IE = "IE",
    IR = "IR",
    IQ = "IQ",
    IS = "IS",
    IL = "IL",
    IT = "IT",
    JM = "JM",
    JE = "JE",
    JO = "JO",
    JP = "JP",
    KZ = "KZ",
    KE = "KE",
    KG = "KG",
    KH = "KH",
    KI = "KI",
    KN = "KN",
    KR = "KR",
    XK = "XK",
    KW = "KW",
    LA = "LA",
    LB = "LB",
    LR = "LR",
    LY = "LY",
    LC = "LC",
    LI = "LI",
    LK = "LK",
    LS = "LS",
    LT = "LT",
    LU = "LU",
    LV = "LV",
    MO = "MO",
    MF = "MF",
    MA = "MA",
    MC = "MC",
    MD = "MD",
    MG = "MG",
    MV = "MV",
    MX = "MX",
    MH = "MH",
    MK = "MK",
    ML = "ML",
    MT = "MT",
    MM = "MM",
    ME = "ME",
    MN = "MN",
    MP = "MP",
    MZ = "MZ",
    MR = "MR",
    MS = "MS",
    MQ = "MQ",
    MU = "MU",
    MW = "MW",
    MY = "MY",
    YT = "YT",
    NA = "NA",
    NC = "NC",
    NE = "NE",
    NF = "NF",
    NG = "NG",
    NI = "NI",
    NU = "NU",
    NL = "NL",
    NO = "NO",
    NP = "NP",
    NR = "NR",
    NZ = "NZ",
    OM = "OM",
    PK = "PK",
    PA = "PA",
    PN = "PN",
    PE = "PE",
    PH = "PH",
    PW = "PW",
    PG = "PG",
    PL = "PL",
    PR = "PR",
    KP = "KP",
    PT = "PT",
    PY = "PY",
    PS = "PS",
    PF = "PF",
    QA = "QA",
    RE = "RE",
    RO = "RO",
    RU = "RU",
    RW = "RW",
    SA = "SA",
    SD = "SD",
    SN = "SN",
    SG = "SG",
    GS = "GS",
    SJ = "SJ",
    SB = "SB",
    SL = "SL",
    SV = "SV",
    SM = "SM",
    SO = "SO",
    PM = "PM",
    RS = "RS",
    SS = "SS",
    ST = "ST",
    SR = "SR",
    SK = "SK",
    SI = "SI",
    SE = "SE",
    SZ = "SZ",
    SX = "SX",
    SC = "SC",
    SY = "SY",
    TC = "TC",
    TD = "TD",
    TG = "TG",
    TH = "TH",
    TJ = "TJ",
    TK = "TK",
    TM = "TM",
    TL = "TL",
    TO = "TO",
    TT = "TT",
    TN = "TN",
    TR = "TR",
    TV = "TV",
    TW = "TW",
    TZ = "TZ",
    UG = "UG",
    UA = "UA",
    UM = "UM",
    UY = "UY",
    US = "US",
    UZ = "UZ",
    VA = "VA",
    VC = "VC",
    VE = "VE",
    VG = "VG",
    VI = "VI",
    VN = "VN",
    VU = "VU",
    WF = "WF",
    WS = "WS",
    YE = "YE",
    ZA = "ZA",
    ZM = "ZM",
    ZW = "ZW",
}

export enum CountryCodeISO3 {
    World = "World",
    ABW = "ABW",
    AFG = "AFG",
    AGO = "AGO",
    AIA = "AIA",
    ALA = "ALA",
    ALB = "ALB",
    AND = "AND",
    ARE = "ARE",
    ARG = "ARG",
    ARM = "ARM",
    ASM = "ASM",
    ATA = "ATA",
    ATF = "ATF",
    ATG = "ATG",
    AUS = "AUS",
    AUT = "AUT",
    AZE = "AZE",
    BDI = "BDI",
    BEL = "BEL",
    BEN = "BEN",
    BFA = "BFA",
    BGD = "BGD",
    BGR = "BGR",
    BHR = "BHR",
    BHS = "BHS",
    BIH = "BIH",
    BLM = "BLM",
    BLR = "BLR",
    BLZ = "BLZ",
    BMU = "BMU",
    BOL = "BOL",
    BRA = "BRA",
    BRB = "BRB",
    BRN = "BRN",
    BTN = "BTN",
    BVT = "BVT",
    BWA = "BWA",
    CAF = "CAF",
    CAN = "CAN",
    CCK = "CCK",
    CHE = "CHE",
    CHL = "CHL",
    CHN = "CHN",
    CIV = "CIV",
    CMR = "CMR",
    COD = "COD",
    COG = "COG",
    COK = "COK",
    COL = "COL",
    COM = "COM",
    CPV = "CPV",
    CRI = "CRI",
    CUB = "CUB",
    CUW = "CUW",
    CXR = "CXR",
    CYM = "CYM",
    CYP = "CYP",
    CZE = "CZE",
    DEU = "DEU",
    DJI = "DJI",
    DMA = "DMA",
    DNK = "DNK",
    DOM = "DOM",
    DZA = "DZA",
    ECU = "ECU",
    EGY = "EGY",
    ERI = "ERI",
    ESH = "ESH",
    ESP = "ESP",
    EST = "EST",
    ETH = "ETH",
    FIN = "FIN",
    FJI = "FJI",
    FLK = "FLK",
    FRA = "FRA",
    FRO = "FRO",
    FSM = "FSM",
    GAB = "GAB",
    GBR = "GBR",
    GEO = "GEO",
    GGY = "GGY",
    GHA = "GHA",
    GIB = "GIB",
    GIN = "GIN",
    GLP = "GLP",
    GMB = "GMB",
    GNB = "GNB",
    GNQ = "GNQ",
    GRC = "GRC",
    GRD = "GRD",
    GRL = "GRL",
    GTM = "GTM",
    GUF = "GUF",
    GUM = "GUM",
    GUY = "GUY",
    HKG = "HKG",
    HMD = "HMD",
    HND = "HND",
    HRV = "HRV",
    HTI = "HTI",
    HUN = "HUN",
    IDN = "IDN",
    IMN = "IMN",
    IND = "IND",
    IOT = "IOT",
    IRL = "IRL",
    IRN = "IRN",
    IRQ = "IRQ",
    ISL = "ISL",
    ISR = "ISR",
    ITA = "ITA",
    JAM = "JAM",
    JEY = "JEY",
    JOR = "JOR",
    JPN = "JPN",
    KAZ = "KAZ",
    KEN = "KEN",
    KGZ = "KGZ",
    KHM = "KHM",
    KIR = "KIR",
    KNA = "KNA",
    KOR = "KOR",
    KOS = "KOS",
    KWT = "KWT",
    LAO = "LAO",
    LBN = "LBN",
    LBR = "LBR",
    LBY = "LBY",
    LCA = "LCA",
    LIE = "LIE",
    LKA = "LKA",
    LSO = "LSO",
    LTU = "LTU",
    LUX = "LUX",
    LVA = "LVA",
    MAC = "MAC",
    MAF = "MAF",
    MAR = "MAR",
    MCO = "MCO",
    MDA = "MDA",
    MDG = "MDG",
    MDV = "MDV",
    MEX = "MEX",
    MHL = "MHL",
    MKD = "MKD",
    MLI = "MLI",
    MLT = "MLT",
    MMR = "MMR",
    MNE = "MNE",
    MNG = "MNG",
    MNP = "MNP",
    MOZ = "MOZ",
    MRT = "MRT",
    MSR = "MSR",
    MTQ = "MTQ",
    MUS = "MUS",
    MWI = "MWI",
    MYS = "MYS",
    MYT = "MYT",
    NAM = "NAM",
    NCL = "NCL",
    NER = "NER",
    NFK = "NFK",
    NGA = "NGA",
    NIC = "NIC",
    NIU = "NIU",
    NLD = "NLD",
    NOR = "NOR",
    NPL = "NPL",
    NRU = "NRU",
    NZL = "NZL",
    OMN = "OMN",
    PAK = "PAK",
    PAN = "PAN",
    PCN = "PCN",
    PER = "PER",
    PHL = "PHL",
    PLW = "PLW",
    PNG = "PNG",
    POL = "POL",
    PRI = "PRI",
    PRK = "PRK",
    PRT = "PRT",
    PRY = "PRY",
    PSE = "PSE",
    PYF = "PYF",
    QAT = "QAT",
    REU = "REU",
    ROU = "ROU",
    RUS = "RUS",
    RWA = "RWA",
    SAU = "SAU",
    SDN = "SDN",
    SEN = "SEN",
    SGP = "SGP",
    SGS = "SGS",
    SJM = "SJM",
    SLB = "SLB",
    SLE = "SLE",
    SLV = "SLV",
    SMR = "SMR",
    SOM = "SOM",
    SPM = "SPM",
    SRB = "SRB",
    SSD = "SSD",
    STP = "STP",
    SUR = "SUR",
    SVK = "SVK",
    SVN = "SVN",
    SWE = "SWE",
    SWZ = "SWZ",
    SXM = "SXM",
    SYC = "SYC",
    SYR = "SYR",
    TCA = "TCA",
    TCD = "TCD",
    TGO = "TGO",
    THA = "THA",
    TJK = "TJK",
    TKL = "TKL",
    TKM = "TKM",
    TLS = "TLS",
    TON = "TON",
    TTO = "TTO",
    TUN = "TUN",
    TUR = "TUR",
    TUV = "TUV",
    TWN = "TWN",
    TZA = "TZA",
    UGA = "UGA",
    UKR = "UKR",
    UMI = "UMI",
    URY = "URY",
    USA = "USA",
    UZB = "UZB",
    VAT = "VAT",
    VCT = "VCT",
    VEN = "VEN",
    VGB = "VGB",
    VIR = "VIR",
    VNM = "VNM",
    VUT = "VUT",
    WLF = "WLF",
    WSM = "WSM",
    YEM = "YEM",
    ZAF = "ZAF",
    ZMB = "ZMB",
    ZWE = "ZWE",
}

export class CpfInfoResponse implements ICpfInfoResponse {
    name?: string | null;
    dateOfBirth?: string | null;
    isRegistered?: boolean | null;

    constructor(data?: ICpfInfoResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.dateOfBirth = _data["dateOfBirth"] !== undefined ? _data["dateOfBirth"] : <any>null;
            this.isRegistered = _data["isRegistered"] !== undefined ? _data["isRegistered"] : <any>null;
        }
    }

    static fromJS(data: any): CpfInfoResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CpfInfoResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["dateOfBirth"] = this.dateOfBirth !== undefined ? this.dateOfBirth : <any>null;
        data["isRegistered"] = this.isRegistered !== undefined ? this.isRegistered : <any>null;
        return data;
    }
}

export interface ICpfInfoResponse {
    name?: string | null;
    dateOfBirth?: string | null;
    isRegistered?: boolean | null;
}

export class CreateBartenderProfileRequest implements ICreateBartenderProfileRequest {
    verifyPhoneId!: string;
    name!: string;
    language!: string;
    email?: string | null;
    birthDate!: Date;
    gender?: Gender | null;

    constructor(data?: ICreateBartenderProfileRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.verifyPhoneId = _data["verifyPhoneId"] !== undefined ? _data["verifyPhoneId"] : <any>null;
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.language = _data["language"] !== undefined ? _data["language"] : <any>null;
            this.email = _data["email"] !== undefined ? _data["email"] : <any>null;
            this.birthDate = _data["birthDate"] ? new Date(_data["birthDate"].toString()) : <any>null;
            this.gender = _data["gender"] !== undefined ? _data["gender"] : <any>null;
        }
    }

    static fromJS(data: any): CreateBartenderProfileRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreateBartenderProfileRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["verifyPhoneId"] = this.verifyPhoneId !== undefined ? this.verifyPhoneId : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["language"] = this.language !== undefined ? this.language : <any>null;
        data["email"] = this.email !== undefined ? this.email : <any>null;
        data["birthDate"] = this.birthDate ? this.birthDate.toISOString() : <any>null;
        data["gender"] = this.gender !== undefined ? this.gender : <any>null;
        return data;
    }
}

export interface ICreateBartenderProfileRequest {
    verifyPhoneId: string;
    name: string;
    language: string;
    email?: string | null;
    birthDate: Date;
    gender?: Gender | null;
}

export class CreateConsumerProfileRequest implements ICreateConsumerProfileRequest {
    consumerId?: string | null;
    verifyPhoneId!: string;
    language!: string;
    name?: string | null;
    email?: string | null;
    birthDate?: Date | null;
    gender?: Gender | null;
    cpf?: string | null;
    password?: string | null;
    selectedCountry?: string | null;
    tags?: { [key: string]: string; } | null;

    constructor(data?: ICreateConsumerProfileRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.consumerId = _data["consumerId"] !== undefined ? _data["consumerId"] : <any>null;
            this.verifyPhoneId = _data["verifyPhoneId"] !== undefined ? _data["verifyPhoneId"] : <any>null;
            this.language = _data["language"] !== undefined ? _data["language"] : <any>null;
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.email = _data["email"] !== undefined ? _data["email"] : <any>null;
            this.birthDate = _data["birthDate"] ? new Date(_data["birthDate"].toString()) : <any>null;
            this.gender = _data["gender"] !== undefined ? _data["gender"] : <any>null;
            this.cpf = _data["cpf"] !== undefined ? _data["cpf"] : <any>null;
            this.password = _data["password"] !== undefined ? _data["password"] : <any>null;
            this.selectedCountry = _data["selectedCountry"] !== undefined ? _data["selectedCountry"] : <any>null;
            if (_data["tags"]) {
                this.tags = {} as any;
                for (let key in _data["tags"]) {
                    if (_data["tags"].hasOwnProperty(key))
                        (<any>this.tags)![key] = _data["tags"][key] !== undefined ? _data["tags"][key] : <any>null;
                }
            }
            else {
                this.tags = <any>null;
            }
        }
    }

    static fromJS(data: any): CreateConsumerProfileRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreateConsumerProfileRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["consumerId"] = this.consumerId !== undefined ? this.consumerId : <any>null;
        data["verifyPhoneId"] = this.verifyPhoneId !== undefined ? this.verifyPhoneId : <any>null;
        data["language"] = this.language !== undefined ? this.language : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["email"] = this.email !== undefined ? this.email : <any>null;
        data["birthDate"] = this.birthDate ? this.birthDate.toISOString() : <any>null;
        data["gender"] = this.gender !== undefined ? this.gender : <any>null;
        data["cpf"] = this.cpf !== undefined ? this.cpf : <any>null;
        data["password"] = this.password !== undefined ? this.password : <any>null;
        data["selectedCountry"] = this.selectedCountry !== undefined ? this.selectedCountry : <any>null;
        if (this.tags) {
            data["tags"] = {};
            for (let key in this.tags) {
                if (this.tags.hasOwnProperty(key))
                    (<any>data["tags"])[key] = this.tags[key] !== undefined ? this.tags[key] : <any>null;
            }
        }
        return data;
    }
}

export interface ICreateConsumerProfileRequest {
    consumerId?: string | null;
    verifyPhoneId: string;
    language: string;
    name?: string | null;
    email?: string | null;
    birthDate?: Date | null;
    gender?: Gender | null;
    cpf?: string | null;
    password?: string | null;
    selectedCountry?: string | null;
    tags?: { [key: string]: string; } | null;
}

export class CreateProfileRequest implements ICreateProfileRequest {
    phoneNumber?: string | null;
    email?: string | null;
    advertiserId?: string | null;
    birthDate?: string | null;
    language?: string | null;
    gender?: Gender | null;
    firstName?: string | null;
    lastName?: string | null;
    externalUserId?: string | null;

    constructor(data?: ICreateProfileRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.phoneNumber = _data["phoneNumber"] !== undefined ? _data["phoneNumber"] : <any>null;
            this.email = _data["email"] !== undefined ? _data["email"] : <any>null;
            this.advertiserId = _data["advertiserId"] !== undefined ? _data["advertiserId"] : <any>null;
            this.birthDate = _data["birthDate"] !== undefined ? _data["birthDate"] : <any>null;
            this.language = _data["language"] !== undefined ? _data["language"] : <any>null;
            this.gender = _data["gender"] !== undefined ? _data["gender"] : <any>null;
            this.firstName = _data["firstName"] !== undefined ? _data["firstName"] : <any>null;
            this.lastName = _data["lastName"] !== undefined ? _data["lastName"] : <any>null;
            this.externalUserId = _data["externalUserId"] !== undefined ? _data["externalUserId"] : <any>null;
        }
    }

    static fromJS(data: any): CreateProfileRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreateProfileRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["phoneNumber"] = this.phoneNumber !== undefined ? this.phoneNumber : <any>null;
        data["email"] = this.email !== undefined ? this.email : <any>null;
        data["advertiserId"] = this.advertiserId !== undefined ? this.advertiserId : <any>null;
        data["birthDate"] = this.birthDate !== undefined ? this.birthDate : <any>null;
        data["language"] = this.language !== undefined ? this.language : <any>null;
        data["gender"] = this.gender !== undefined ? this.gender : <any>null;
        data["firstName"] = this.firstName !== undefined ? this.firstName : <any>null;
        data["lastName"] = this.lastName !== undefined ? this.lastName : <any>null;
        data["externalUserId"] = this.externalUserId !== undefined ? this.externalUserId : <any>null;
        return data;
    }
}

export interface ICreateProfileRequest {
    phoneNumber?: string | null;
    email?: string | null;
    advertiserId?: string | null;
    birthDate?: string | null;
    language?: string | null;
    gender?: Gender | null;
    firstName?: string | null;
    lastName?: string | null;
    externalUserId?: string | null;
}

export class CreateProfileResponse implements ICreateProfileResponse {
    accountId?: string | null;
    /** is set to true if is new/created, and false if is allready there and updated */
    isCreated?: boolean | null;
    savedCpf?: string | null;

    constructor(data?: ICreateProfileResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accountId = _data["accountId"] !== undefined ? _data["accountId"] : <any>null;
            this.isCreated = _data["isCreated"] !== undefined ? _data["isCreated"] : <any>null;
            this.savedCpf = _data["savedCpf"] !== undefined ? _data["savedCpf"] : <any>null;
        }
    }

    static fromJS(data: any): CreateProfileResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CreateProfileResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accountId"] = this.accountId !== undefined ? this.accountId : <any>null;
        data["isCreated"] = this.isCreated !== undefined ? this.isCreated : <any>null;
        data["savedCpf"] = this.savedCpf !== undefined ? this.savedCpf : <any>null;
        return data;
    }
}

export interface ICreateProfileResponse {
    accountId?: string | null;
    /** is set to true if is new/created, and false if is allready there and updated */
    isCreated?: boolean | null;
    savedCpf?: string | null;
}

export class CreateStaffProfileRequest implements ICreateStaffProfileRequest {
    verifyPhoneId!: string;
    language!: string;
    name?: string | null;
    email?: string | null;
    birthDate?: Date | null;
    gender?: Gender | null;
    cpf?: string | null;
    password?: string | null;
    selectedCountry?: string | null;
    tags?: { [key: string]: string; } | null;

    constructor(data?: ICreateStaffProfileRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.verifyPhoneId = _data["verifyPhoneId"] !== undefined ? _data["verifyPhoneId"] : <any>null;
            this.language = _data["language"] !== undefined ? _data["language"] : <any>null;
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.email = _data["email"] !== undefined ? _data["email"] : <any>null;
            this.birthDate = _data["birthDate"] ? new Date(_data["birthDate"].toString()) : <any>null;
            this.gender = _data["gender"] !== undefined ? _data["gender"] : <any>null;
            this.cpf = _data["cpf"] !== undefined ? _data["cpf"] : <any>null;
            this.password = _data["password"] !== undefined ? _data["password"] : <any>null;
            this.selectedCountry = _data["selectedCountry"] !== undefined ? _data["selectedCountry"] : <any>null;
            if (_data["tags"]) {
                this.tags = {} as any;
                for (let key in _data["tags"]) {
                    if (_data["tags"].hasOwnProperty(key))
                        (<any>this.tags)![key] = _data["tags"][key] !== undefined ? _data["tags"][key] : <any>null;
                }
            }
            else {
                this.tags = <any>null;
            }
        }
    }

    static fromJS(data: any): CreateStaffProfileRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreateStaffProfileRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["verifyPhoneId"] = this.verifyPhoneId !== undefined ? this.verifyPhoneId : <any>null;
        data["language"] = this.language !== undefined ? this.language : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["email"] = this.email !== undefined ? this.email : <any>null;
        data["birthDate"] = this.birthDate ? this.birthDate.toISOString() : <any>null;
        data["gender"] = this.gender !== undefined ? this.gender : <any>null;
        data["cpf"] = this.cpf !== undefined ? this.cpf : <any>null;
        data["password"] = this.password !== undefined ? this.password : <any>null;
        data["selectedCountry"] = this.selectedCountry !== undefined ? this.selectedCountry : <any>null;
        if (this.tags) {
            data["tags"] = {};
            for (let key in this.tags) {
                if (this.tags.hasOwnProperty(key))
                    (<any>data["tags"])[key] = this.tags[key] !== undefined ? this.tags[key] : <any>null;
            }
        }
        return data;
    }
}

export interface ICreateStaffProfileRequest {
    verifyPhoneId: string;
    language: string;
    name?: string | null;
    email?: string | null;
    birthDate?: Date | null;
    gender?: Gender | null;
    cpf?: string | null;
    password?: string | null;
    selectedCountry?: string | null;
    tags?: { [key: string]: string; } | null;
}

export class ErrorResponse implements IErrorResponse {
    errorMessage?: string | null;
    errorCode?: string | null;

    constructor(data?: IErrorResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.errorMessage = _data["errorMessage"] !== undefined ? _data["errorMessage"] : <any>null;
            this.errorCode = _data["errorCode"] !== undefined ? _data["errorCode"] : <any>null;
        }
    }

    static fromJS(data: any): ErrorResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ErrorResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["errorMessage"] = this.errorMessage !== undefined ? this.errorMessage : <any>null;
        data["errorCode"] = this.errorCode !== undefined ? this.errorCode : <any>null;
        return data;
    }
}

export interface IErrorResponse {
    errorMessage?: string | null;
    errorCode?: string | null;
}

export enum Gender {
    Male = "Male",
    Female = "Female",
    Other = "Other",
}

/** Identifier model */
export class Identifier implements IIdentifier {
    /** Possible values: email, phone */
    key?: string | null;
    /** Value */
    value?: string | null;

    constructor(data?: IIdentifier) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.key = _data["key"] !== undefined ? _data["key"] : <any>null;
            this.value = _data["value"] !== undefined ? _data["value"] : <any>null;
        }
    }

    static fromJS(data: any): Identifier {
        data = typeof data === 'object' ? data : {};
        let result = new Identifier();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["key"] = this.key !== undefined ? this.key : <any>null;
        data["value"] = this.value !== undefined ? this.value : <any>null;
        return data;
    }
}

/** Identifier model */
export interface IIdentifier {
    /** Possible values: email, phone */
    key?: string | null;
    /** Value */
    value?: string | null;
}

export class ImageSaveResult implements IImageSaveResult {
    imageUrl?: string | null;
    /** The url of the low quality image */
    lowImageUrl?: string | null;

    constructor(data?: IImageSaveResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.imageUrl = _data["imageUrl"] !== undefined ? _data["imageUrl"] : <any>null;
            this.lowImageUrl = _data["lowImageUrl"] !== undefined ? _data["lowImageUrl"] : <any>null;
        }
    }

    static fromJS(data: any): ImageSaveResult {
        data = typeof data === 'object' ? data : {};
        let result = new ImageSaveResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["imageUrl"] = this.imageUrl !== undefined ? this.imageUrl : <any>null;
        data["lowImageUrl"] = this.lowImageUrl !== undefined ? this.lowImageUrl : <any>null;
        return data;
    }
}

export interface IImageSaveResult {
    imageUrl?: string | null;
    /** The url of the low quality image */
    lowImageUrl?: string | null;
}

/** Marketing consent request model */
export class MarketingConsentRequest implements IMarketingConsentRequest {
    /** Identifier list */
    identifier?: Identifier[] | null;
    channel?: ChannelConsent | null;

    constructor(data?: IMarketingConsentRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["identifier"])) {
                this.identifier = [] as any;
                for (let item of _data["identifier"])
                    this.identifier!.push(Identifier.fromJS(item));
            }
            else {
                this.identifier = <any>null;
            }
            this.channel = _data["channel"] ? ChannelConsent.fromJS(_data["channel"]) : <any>null;
        }
    }

    static fromJS(data: any): MarketingConsentRequest {
        data = typeof data === 'object' ? data : {};
        let result = new MarketingConsentRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.identifier)) {
            data["identifier"] = [];
            for (let item of this.identifier)
                data["identifier"].push(item.toJSON());
        }
        data["channel"] = this.channel ? this.channel.toJSON() : <any>null;
        return data;
    }
}

/** Marketing consent request model */
export interface IMarketingConsentRequest {
    /** Identifier list */
    identifier?: Identifier[] | null;
    channel?: ChannelConsent | null;
}

export enum MobileOS {
    IoS = "IoS",
    Android = "Android",
}

export class ModelError implements IModelError {
    exception?: any | null;
    errorMessage?: string | null;

    constructor(data?: IModelError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.exception = _data["exception"] !== undefined ? _data["exception"] : <any>null;
            this.errorMessage = _data["errorMessage"] !== undefined ? _data["errorMessage"] : <any>null;
        }
    }

    static fromJS(data: any): ModelError {
        data = typeof data === 'object' ? data : {};
        let result = new ModelError();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["exception"] = this.exception !== undefined ? this.exception : <any>null;
        data["errorMessage"] = this.errorMessage !== undefined ? this.errorMessage : <any>null;
        return data;
    }
}

export interface IModelError {
    exception?: any | null;
    errorMessage?: string | null;
}

export class ModelStateEntry implements IModelStateEntry {
    rawValue?: any | null;
    attemptedValue?: string | null;
    readonly errors?: ModelError[] | null;
    validationState?: ModelValidationState | null;
    readonly isContainerNode?: boolean | null;
    readonly children?: ModelStateEntry[] | null;

    constructor(data?: IModelStateEntry) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.rawValue = _data["rawValue"] !== undefined ? _data["rawValue"] : <any>null;
            this.attemptedValue = _data["attemptedValue"] !== undefined ? _data["attemptedValue"] : <any>null;
            if (Array.isArray(_data["errors"])) {
                (<any>this).errors = [] as any;
                for (let item of _data["errors"])
                    (<any>this).errors!.push(ModelError.fromJS(item));
            }
            else {
                (<any>this).errors = <any>null;
            }
            this.validationState = _data["validationState"] !== undefined ? _data["validationState"] : <any>null;
            (<any>this).isContainerNode = _data["isContainerNode"] !== undefined ? _data["isContainerNode"] : <any>null;
            if (Array.isArray(_data["children"])) {
                (<any>this).children = [] as any;
                for (let item of _data["children"])
                    (<any>this).children!.push(ModelStateEntry.fromJS(item));
            }
            else {
                (<any>this).children = <any>null;
            }
        }
    }

    static fromJS(data: any): ModelStateEntry {
        data = typeof data === 'object' ? data : {};
        let result = new ModelStateEntry();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["rawValue"] = this.rawValue !== undefined ? this.rawValue : <any>null;
        data["attemptedValue"] = this.attemptedValue !== undefined ? this.attemptedValue : <any>null;
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item.toJSON());
        }
        data["validationState"] = this.validationState !== undefined ? this.validationState : <any>null;
        data["isContainerNode"] = this.isContainerNode !== undefined ? this.isContainerNode : <any>null;
        if (Array.isArray(this.children)) {
            data["children"] = [];
            for (let item of this.children)
                data["children"].push(item.toJSON());
        }
        return data;
    }
}

export interface IModelStateEntry {
    rawValue?: any | null;
    attemptedValue?: string | null;
    errors?: ModelError[] | null;
    validationState?: ModelValidationState | null;
    isContainerNode?: boolean | null;
    children?: ModelStateEntry[] | null;
}

export enum ModelValidationState {
    Unvalidated = "Unvalidated",
    Invalid = "Invalid",
    Valid = "Valid",
    Skipped = "Skipped",
}

export enum NotificationChannel {
    Phone = "Phone",
    Email = "Email",
    Whatsapp = "Whatsapp",
}

export class PhoneDevice implements IPhoneDevice {
    status?: PhoneDeviceStatus | null;
    deviceModel?: string | null;
    appVersion?: string | null;
    id?: string | null;
    createdAt?: Date | null;
    updatedAt?: Date | null;

    constructor(data?: IPhoneDevice) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.status = _data["status"] !== undefined ? _data["status"] : <any>null;
            this.deviceModel = _data["deviceModel"] !== undefined ? _data["deviceModel"] : <any>null;
            this.appVersion = _data["appVersion"] !== undefined ? _data["appVersion"] : <any>null;
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : <any>null;
            this.updatedAt = _data["updatedAt"] ? new Date(_data["updatedAt"].toString()) : <any>null;
        }
    }

    static fromJS(data: any): PhoneDevice {
        data = typeof data === 'object' ? data : {};
        let result = new PhoneDevice();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status !== undefined ? this.status : <any>null;
        data["deviceModel"] = this.deviceModel !== undefined ? this.deviceModel : <any>null;
        data["appVersion"] = this.appVersion !== undefined ? this.appVersion : <any>null;
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : <any>null;
        data["updatedAt"] = this.updatedAt ? this.updatedAt.toISOString() : <any>null;
        return data;
    }
}

export interface IPhoneDevice {
    status?: PhoneDeviceStatus | null;
    deviceModel?: string | null;
    appVersion?: string | null;
    id?: string | null;
    createdAt?: Date | null;
    updatedAt?: Date | null;
}

export enum PhoneDeviceStatus {
    Active = "Active",
    Locked = "Locked",
}

export enum PhoneVerificationType {
    SMS = "SMS",
    TTS = "TTS",
    WhatsApp = "WhatsApp",
}

export class ProfileQueryFilter implements IProfileQueryFilter {
    phoneNumbers?: string[] | null;
    name?: string[] | null;
    firstName?: string[] | null;
    lastName?: string[] | null;
    status?: AccountStatus | null;
    countries?: string[] | null;
    emails?: string[] | null;
    validatedEmails?: string[] | null;
    roles?: string[] | null;
    lables?: string[] | null;
    tags?: TagQueryItem[] | null;
    nextToken?: string | null;

    constructor(data?: IProfileQueryFilter) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["phoneNumbers"])) {
                this.phoneNumbers = [] as any;
                for (let item of _data["phoneNumbers"])
                    this.phoneNumbers!.push(item);
            }
            else {
                this.phoneNumbers = <any>null;
            }
            if (Array.isArray(_data["name"])) {
                this.name = [] as any;
                for (let item of _data["name"])
                    this.name!.push(item);
            }
            else {
                this.name = <any>null;
            }
            if (Array.isArray(_data["firstName"])) {
                this.firstName = [] as any;
                for (let item of _data["firstName"])
                    this.firstName!.push(item);
            }
            else {
                this.firstName = <any>null;
            }
            if (Array.isArray(_data["lastName"])) {
                this.lastName = [] as any;
                for (let item of _data["lastName"])
                    this.lastName!.push(item);
            }
            else {
                this.lastName = <any>null;
            }
            this.status = _data["status"] !== undefined ? _data["status"] : <any>null;
            if (Array.isArray(_data["countries"])) {
                this.countries = [] as any;
                for (let item of _data["countries"])
                    this.countries!.push(item);
            }
            else {
                this.countries = <any>null;
            }
            if (Array.isArray(_data["emails"])) {
                this.emails = [] as any;
                for (let item of _data["emails"])
                    this.emails!.push(item);
            }
            else {
                this.emails = <any>null;
            }
            if (Array.isArray(_data["validatedEmails"])) {
                this.validatedEmails = [] as any;
                for (let item of _data["validatedEmails"])
                    this.validatedEmails!.push(item);
            }
            else {
                this.validatedEmails = <any>null;
            }
            if (Array.isArray(_data["roles"])) {
                this.roles = [] as any;
                for (let item of _data["roles"])
                    this.roles!.push(item);
            }
            else {
                this.roles = <any>null;
            }
            if (Array.isArray(_data["lables"])) {
                this.lables = [] as any;
                for (let item of _data["lables"])
                    this.lables!.push(item);
            }
            else {
                this.lables = <any>null;
            }
            if (Array.isArray(_data["tags"])) {
                this.tags = [] as any;
                for (let item of _data["tags"])
                    this.tags!.push(TagQueryItem.fromJS(item));
            }
            else {
                this.tags = <any>null;
            }
            this.nextToken = _data["nextToken"] !== undefined ? _data["nextToken"] : <any>null;
        }
    }

    static fromJS(data: any): ProfileQueryFilter {
        data = typeof data === 'object' ? data : {};
        let result = new ProfileQueryFilter();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.phoneNumbers)) {
            data["phoneNumbers"] = [];
            for (let item of this.phoneNumbers)
                data["phoneNumbers"].push(item);
        }
        if (Array.isArray(this.name)) {
            data["name"] = [];
            for (let item of this.name)
                data["name"].push(item);
        }
        if (Array.isArray(this.firstName)) {
            data["firstName"] = [];
            for (let item of this.firstName)
                data["firstName"].push(item);
        }
        if (Array.isArray(this.lastName)) {
            data["lastName"] = [];
            for (let item of this.lastName)
                data["lastName"].push(item);
        }
        data["status"] = this.status !== undefined ? this.status : <any>null;
        if (Array.isArray(this.countries)) {
            data["countries"] = [];
            for (let item of this.countries)
                data["countries"].push(item);
        }
        if (Array.isArray(this.emails)) {
            data["emails"] = [];
            for (let item of this.emails)
                data["emails"].push(item);
        }
        if (Array.isArray(this.validatedEmails)) {
            data["validatedEmails"] = [];
            for (let item of this.validatedEmails)
                data["validatedEmails"].push(item);
        }
        if (Array.isArray(this.roles)) {
            data["roles"] = [];
            for (let item of this.roles)
                data["roles"].push(item);
        }
        if (Array.isArray(this.lables)) {
            data["lables"] = [];
            for (let item of this.lables)
                data["lables"].push(item);
        }
        if (Array.isArray(this.tags)) {
            data["tags"] = [];
            for (let item of this.tags)
                data["tags"].push(item.toJSON());
        }
        data["nextToken"] = this.nextToken !== undefined ? this.nextToken : <any>null;
        return data;
    }
}

export interface IProfileQueryFilter {
    phoneNumbers?: string[] | null;
    name?: string[] | null;
    firstName?: string[] | null;
    lastName?: string[] | null;
    status?: AccountStatus | null;
    countries?: string[] | null;
    emails?: string[] | null;
    validatedEmails?: string[] | null;
    roles?: string[] | null;
    lables?: string[] | null;
    tags?: TagQueryItem[] | null;
    nextToken?: string | null;
}

export class ProfileQueryResponse implements IProfileQueryResponse {
    profiles?: ProfileResponse[] | null;
    totalResults?: number | null;
    nextToken?: string | null;

    constructor(data?: IProfileQueryResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["profiles"])) {
                this.profiles = [] as any;
                for (let item of _data["profiles"])
                    this.profiles!.push(ProfileResponse.fromJS(item));
            }
            else {
                this.profiles = <any>null;
            }
            this.totalResults = _data["totalResults"] !== undefined ? _data["totalResults"] : <any>null;
            this.nextToken = _data["nextToken"] !== undefined ? _data["nextToken"] : <any>null;
        }
    }

    static fromJS(data: any): ProfileQueryResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ProfileQueryResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.profiles)) {
            data["profiles"] = [];
            for (let item of this.profiles)
                data["profiles"].push(item.toJSON());
        }
        data["totalResults"] = this.totalResults !== undefined ? this.totalResults : <any>null;
        data["nextToken"] = this.nextToken !== undefined ? this.nextToken : <any>null;
        return data;
    }
}

export interface IProfileQueryResponse {
    profiles?: ProfileResponse[] | null;
    totalResults?: number | null;
    nextToken?: string | null;
}

export class ProfileResponse implements IProfileResponse {
    id?: string | null;
    name?: string | null;
    firstName?: string | null;
    lastName?: string | null;
    phoneNumber?: string | null;
    email?: string | null;
    validatedEmail?: string | null;
    pendingValidationEmail?: string | null;
    status?: AccountStatus | null;
    country?: string | null;
    gender?: Gender | null;
    birthday?: Date | null;
    avatarUrl?: string | null;
    avatarLowUrl?: string | null;
    language?: string | null;
    createdAt?: Date | null;
    tosAccepted?: Date | null;
    roles?: string[] | null;
    tags?: UserTag[] | null;
    labels?: UserLabel[] | null;
    selectedCountry?: string | null;
    cpf?: string | null;

    constructor(data?: IProfileResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.firstName = _data["firstName"] !== undefined ? _data["firstName"] : <any>null;
            this.lastName = _data["lastName"] !== undefined ? _data["lastName"] : <any>null;
            this.phoneNumber = _data["phoneNumber"] !== undefined ? _data["phoneNumber"] : <any>null;
            this.email = _data["email"] !== undefined ? _data["email"] : <any>null;
            this.validatedEmail = _data["validatedEmail"] !== undefined ? _data["validatedEmail"] : <any>null;
            this.pendingValidationEmail = _data["pendingValidationEmail"] !== undefined ? _data["pendingValidationEmail"] : <any>null;
            this.status = _data["status"] !== undefined ? _data["status"] : <any>null;
            this.country = _data["country"] !== undefined ? _data["country"] : <any>null;
            this.gender = _data["gender"] !== undefined ? _data["gender"] : <any>null;
            this.birthday = _data["birthday"] ? new Date(_data["birthday"].toString()) : <any>null;
            this.avatarUrl = _data["avatarUrl"] !== undefined ? _data["avatarUrl"] : <any>null;
            this.avatarLowUrl = _data["avatarLowUrl"] !== undefined ? _data["avatarLowUrl"] : <any>null;
            this.language = _data["language"] !== undefined ? _data["language"] : <any>null;
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : <any>null;
            this.tosAccepted = _data["tosAccepted"] ? new Date(_data["tosAccepted"].toString()) : <any>null;
            if (Array.isArray(_data["roles"])) {
                this.roles = [] as any;
                for (let item of _data["roles"])
                    this.roles!.push(item);
            }
            else {
                this.roles = <any>null;
            }
            if (Array.isArray(_data["tags"])) {
                this.tags = [] as any;
                for (let item of _data["tags"])
                    this.tags!.push(UserTag.fromJS(item));
            }
            else {
                this.tags = <any>null;
            }
            if (Array.isArray(_data["labels"])) {
                this.labels = [] as any;
                for (let item of _data["labels"])
                    this.labels!.push(UserLabel.fromJS(item));
            }
            else {
                this.labels = <any>null;
            }
            this.selectedCountry = _data["selectedCountry"] !== undefined ? _data["selectedCountry"] : <any>null;
            this.cpf = _data["cpf"] !== undefined ? _data["cpf"] : <any>null;
        }
    }

    static fromJS(data: any): ProfileResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ProfileResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["firstName"] = this.firstName !== undefined ? this.firstName : <any>null;
        data["lastName"] = this.lastName !== undefined ? this.lastName : <any>null;
        data["phoneNumber"] = this.phoneNumber !== undefined ? this.phoneNumber : <any>null;
        data["email"] = this.email !== undefined ? this.email : <any>null;
        data["validatedEmail"] = this.validatedEmail !== undefined ? this.validatedEmail : <any>null;
        data["pendingValidationEmail"] = this.pendingValidationEmail !== undefined ? this.pendingValidationEmail : <any>null;
        data["status"] = this.status !== undefined ? this.status : <any>null;
        data["country"] = this.country !== undefined ? this.country : <any>null;
        data["gender"] = this.gender !== undefined ? this.gender : <any>null;
        data["birthday"] = this.birthday ? this.birthday.toISOString() : <any>null;
        data["avatarUrl"] = this.avatarUrl !== undefined ? this.avatarUrl : <any>null;
        data["avatarLowUrl"] = this.avatarLowUrl !== undefined ? this.avatarLowUrl : <any>null;
        data["language"] = this.language !== undefined ? this.language : <any>null;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : <any>null;
        data["tosAccepted"] = this.tosAccepted ? this.tosAccepted.toISOString() : <any>null;
        if (Array.isArray(this.roles)) {
            data["roles"] = [];
            for (let item of this.roles)
                data["roles"].push(item);
        }
        if (Array.isArray(this.tags)) {
            data["tags"] = [];
            for (let item of this.tags)
                data["tags"].push(item.toJSON());
        }
        if (Array.isArray(this.labels)) {
            data["labels"] = [];
            for (let item of this.labels)
                data["labels"].push(item.toJSON());
        }
        data["selectedCountry"] = this.selectedCountry !== undefined ? this.selectedCountry : <any>null;
        data["cpf"] = this.cpf !== undefined ? this.cpf : <any>null;
        return data;
    }
}

export interface IProfileResponse {
    id?: string | null;
    name?: string | null;
    firstName?: string | null;
    lastName?: string | null;
    phoneNumber?: string | null;
    email?: string | null;
    validatedEmail?: string | null;
    pendingValidationEmail?: string | null;
    status?: AccountStatus | null;
    country?: string | null;
    gender?: Gender | null;
    birthday?: Date | null;
    avatarUrl?: string | null;
    avatarLowUrl?: string | null;
    language?: string | null;
    createdAt?: Date | null;
    tosAccepted?: Date | null;
    roles?: string[] | null;
    tags?: UserTag[] | null;
    labels?: UserLabel[] | null;
    selectedCountry?: string | null;
    cpf?: string | null;
}

export class ProfileResponseTokenResponseValueTuple implements IProfileResponseTokenResponseValueTuple {
    item1?: ProfileResponse | null;
    item2?: TokenResponse | null;

    constructor(data?: IProfileResponseTokenResponseValueTuple) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.item1 = _data["item1"] ? ProfileResponse.fromJS(_data["item1"]) : <any>null;
            this.item2 = _data["item2"] ? TokenResponse.fromJS(_data["item2"]) : <any>null;
        }
    }

    static fromJS(data: any): ProfileResponseTokenResponseValueTuple {
        data = typeof data === 'object' ? data : {};
        let result = new ProfileResponseTokenResponseValueTuple();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["item1"] = this.item1 ? this.item1.toJSON() : <any>null;
        data["item2"] = this.item2 ? this.item2.toJSON() : <any>null;
        return data;
    }
}

export interface IProfileResponseTokenResponseValueTuple {
    item1?: ProfileResponse | null;
    item2?: TokenResponse | null;
}

export class PublicProfileResponse implements IPublicProfileResponse {
    id?: string | null;
    name?: string | null;
    avatarUrl?: string | null;
    avatarLowUrl?: string | null;

    constructor(data?: IPublicProfileResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.avatarUrl = _data["avatarUrl"] !== undefined ? _data["avatarUrl"] : <any>null;
            this.avatarLowUrl = _data["avatarLowUrl"] !== undefined ? _data["avatarLowUrl"] : <any>null;
        }
    }

    static fromJS(data: any): PublicProfileResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PublicProfileResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["avatarUrl"] = this.avatarUrl !== undefined ? this.avatarUrl : <any>null;
        data["avatarLowUrl"] = this.avatarLowUrl !== undefined ? this.avatarLowUrl : <any>null;
        return data;
    }
}

export interface IPublicProfileResponse {
    id?: string | null;
    name?: string | null;
    avatarUrl?: string | null;
    avatarLowUrl?: string | null;
}

export class RecoverPasswordRequest implements IRecoverPasswordRequest {
    verificationId!: string;
    cpf!: string;
    phoneNumber!: string;
    password?: string | null;
    deviceId!: string;
    applicationId!: string;

    constructor(data?: IRecoverPasswordRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.verificationId = _data["verificationId"] !== undefined ? _data["verificationId"] : <any>null;
            this.cpf = _data["cpf"] !== undefined ? _data["cpf"] : <any>null;
            this.phoneNumber = _data["phoneNumber"] !== undefined ? _data["phoneNumber"] : <any>null;
            this.password = _data["password"] !== undefined ? _data["password"] : <any>null;
            this.deviceId = _data["deviceId"] !== undefined ? _data["deviceId"] : <any>null;
            this.applicationId = _data["applicationId"] !== undefined ? _data["applicationId"] : <any>null;
        }
    }

    static fromJS(data: any): RecoverPasswordRequest {
        data = typeof data === 'object' ? data : {};
        let result = new RecoverPasswordRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["verificationId"] = this.verificationId !== undefined ? this.verificationId : <any>null;
        data["cpf"] = this.cpf !== undefined ? this.cpf : <any>null;
        data["phoneNumber"] = this.phoneNumber !== undefined ? this.phoneNumber : <any>null;
        data["password"] = this.password !== undefined ? this.password : <any>null;
        data["deviceId"] = this.deviceId !== undefined ? this.deviceId : <any>null;
        data["applicationId"] = this.applicationId !== undefined ? this.applicationId : <any>null;
        return data;
    }
}

export interface IRecoverPasswordRequest {
    verificationId: string;
    cpf: string;
    phoneNumber: string;
    password?: string | null;
    deviceId: string;
    applicationId: string;
}

/** Refresh token request */
export class RefreshTokenRequest implements IRefreshTokenRequest {
    /** The access token */
    accessToken?: string | null;
    /** The refresh token */
    refreshToken?: string | null;
    /** The validation id */
    validationId?: string | null;

    constructor(data?: IRefreshTokenRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accessToken = _data["accessToken"] !== undefined ? _data["accessToken"] : <any>null;
            this.refreshToken = _data["refreshToken"] !== undefined ? _data["refreshToken"] : <any>null;
            this.validationId = _data["validationId"] !== undefined ? _data["validationId"] : <any>null;
        }
    }

    static fromJS(data: any): RefreshTokenRequest {
        data = typeof data === 'object' ? data : {};
        let result = new RefreshTokenRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accessToken"] = this.accessToken !== undefined ? this.accessToken : <any>null;
        data["refreshToken"] = this.refreshToken !== undefined ? this.refreshToken : <any>null;
        data["validationId"] = this.validationId !== undefined ? this.validationId : <any>null;
        return data;
    }
}

/** Refresh token request */
export interface IRefreshTokenRequest {
    /** The access token */
    accessToken?: string | null;
    /** The refresh token */
    refreshToken?: string | null;
    /** The validation id */
    validationId?: string | null;
}

export class RegistrationConfigDto implements IRegistrationConfigDto {
    userPoolId?: string | null;
    isRegistrationEnabled?: boolean | null;
    allowAdminCreateUserOnly?: boolean | null;

    constructor(data?: IRegistrationConfigDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userPoolId = _data["userPoolId"] !== undefined ? _data["userPoolId"] : <any>null;
            this.isRegistrationEnabled = _data["isRegistrationEnabled"] !== undefined ? _data["isRegistrationEnabled"] : <any>null;
            this.allowAdminCreateUserOnly = _data["allowAdminCreateUserOnly"] !== undefined ? _data["allowAdminCreateUserOnly"] : <any>null;
        }
    }

    static fromJS(data: any): RegistrationConfigDto {
        data = typeof data === 'object' ? data : {};
        let result = new RegistrationConfigDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userPoolId"] = this.userPoolId !== undefined ? this.userPoolId : <any>null;
        data["isRegistrationEnabled"] = this.isRegistrationEnabled !== undefined ? this.isRegistrationEnabled : <any>null;
        data["allowAdminCreateUserOnly"] = this.allowAdminCreateUserOnly !== undefined ? this.allowAdminCreateUserOnly : <any>null;
        return data;
    }
}

export interface IRegistrationConfigDto {
    userPoolId?: string | null;
    isRegistrationEnabled?: boolean | null;
    allowAdminCreateUserOnly?: boolean | null;
}

export class Role implements IRole {
    roleValue?: Roles | null;
    readonly name?: string | null;

    constructor(data?: IRole) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.roleValue = _data["roleValue"] !== undefined ? _data["roleValue"] : <any>null;
            (<any>this).name = _data["name"] !== undefined ? _data["name"] : <any>null;
        }
    }

    static fromJS(data: any): Role {
        data = typeof data === 'object' ? data : {};
        let result = new Role();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["roleValue"] = this.roleValue !== undefined ? this.roleValue : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        return data;
    }
}

export interface IRole {
    roleValue?: Roles | null;
    name?: string | null;
}

export enum Roles {
    Bartender = "Bartender",
    BartenderRedemption = "BartenderRedemption",
    Consumer = "Consumer",
    Promoter = "Promoter",
    OrganizationOwner = "OrganizationOwner",
    Advertiser = "Advertiser",
    Staff = "Staff",
}

export class SimpleProfileQueryFilter implements ISimpleProfileQueryFilter {
    phoneNumber?: string | null;
    name?: string | null;
    nextToken?: string | null;

    constructor(data?: ISimpleProfileQueryFilter) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.phoneNumber = _data["phoneNumber"] !== undefined ? _data["phoneNumber"] : <any>null;
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.nextToken = _data["nextToken"] !== undefined ? _data["nextToken"] : <any>null;
        }
    }

    static fromJS(data: any): SimpleProfileQueryFilter {
        data = typeof data === 'object' ? data : {};
        let result = new SimpleProfileQueryFilter();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["phoneNumber"] = this.phoneNumber !== undefined ? this.phoneNumber : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["nextToken"] = this.nextToken !== undefined ? this.nextToken : <any>null;
        return data;
    }
}

export interface ISimpleProfileQueryFilter {
    phoneNumber?: string | null;
    name?: string | null;
    nextToken?: string | null;
}

export enum SubscriptionStatus {
    Unsubscribe = "Unsubscribe",
    Resubscribe = "Resubscribe",
}

export class TagQueryItem implements ITagQueryItem {
    tag?: string | null;
    value?: string | null;

    constructor(data?: ITagQueryItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tag = _data["tag"] !== undefined ? _data["tag"] : <any>null;
            this.value = _data["value"] !== undefined ? _data["value"] : <any>null;
        }
    }

    static fromJS(data: any): TagQueryItem {
        data = typeof data === 'object' ? data : {};
        let result = new TagQueryItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tag"] = this.tag !== undefined ? this.tag : <any>null;
        data["value"] = this.value !== undefined ? this.value : <any>null;
        return data;
    }
}

export interface ITagQueryItem {
    tag?: string | null;
    value?: string | null;
}

export class TokenRequest implements ITokenRequest {
    code?: string | null;
    state?: string | null;

    constructor(data?: ITokenRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.code = _data["code"] !== undefined ? _data["code"] : <any>null;
            this.state = _data["state"] !== undefined ? _data["state"] : <any>null;
        }
    }

    static fromJS(data: any): TokenRequest {
        data = typeof data === 'object' ? data : {};
        let result = new TokenRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code !== undefined ? this.code : <any>null;
        data["state"] = this.state !== undefined ? this.state : <any>null;
        return data;
    }
}

export interface ITokenRequest {
    code?: string | null;
    state?: string | null;
}

export class TokenResponse implements ITokenResponse {
    accessToken?: string | null;
    refreshToken?: string | null;
    accountId?: string | null;
    sessionId?: string | null;
    returnUrl?: string | null;

    constructor(data?: ITokenResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accessToken = _data["accessToken"] !== undefined ? _data["accessToken"] : <any>null;
            this.refreshToken = _data["refreshToken"] !== undefined ? _data["refreshToken"] : <any>null;
            this.accountId = _data["accountId"] !== undefined ? _data["accountId"] : <any>null;
            this.sessionId = _data["sessionId"] !== undefined ? _data["sessionId"] : <any>null;
            this.returnUrl = _data["returnUrl"] !== undefined ? _data["returnUrl"] : <any>null;
        }
    }

    static fromJS(data: any): TokenResponse {
        data = typeof data === 'object' ? data : {};
        let result = new TokenResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accessToken"] = this.accessToken !== undefined ? this.accessToken : <any>null;
        data["refreshToken"] = this.refreshToken !== undefined ? this.refreshToken : <any>null;
        data["accountId"] = this.accountId !== undefined ? this.accountId : <any>null;
        data["sessionId"] = this.sessionId !== undefined ? this.sessionId : <any>null;
        data["returnUrl"] = this.returnUrl !== undefined ? this.returnUrl : <any>null;
        return data;
    }
}

export interface ITokenResponse {
    accessToken?: string | null;
    refreshToken?: string | null;
    accountId?: string | null;
    sessionId?: string | null;
    returnUrl?: string | null;
}

export class UpdateProfileRequest implements IUpdateProfileRequest {
    firstName?: string | null;
    lastName?: string | null;
    birthDate?: Date | null;
    language!: string;
    gender?: Gender | null;
    country?: string | null;
    latestEmail?: string | null;

    constructor(data?: IUpdateProfileRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.firstName = _data["firstName"] !== undefined ? _data["firstName"] : <any>null;
            this.lastName = _data["lastName"] !== undefined ? _data["lastName"] : <any>null;
            this.birthDate = _data["birthDate"] ? new Date(_data["birthDate"].toString()) : <any>null;
            this.language = _data["language"] !== undefined ? _data["language"] : <any>null;
            this.gender = _data["gender"] !== undefined ? _data["gender"] : <any>null;
            this.country = _data["country"] !== undefined ? _data["country"] : <any>null;
            this.latestEmail = _data["latestEmail"] !== undefined ? _data["latestEmail"] : <any>null;
        }
    }

    static fromJS(data: any): UpdateProfileRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateProfileRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["firstName"] = this.firstName !== undefined ? this.firstName : <any>null;
        data["lastName"] = this.lastName !== undefined ? this.lastName : <any>null;
        data["birthDate"] = this.birthDate ? this.birthDate.toISOString() : <any>null;
        data["language"] = this.language !== undefined ? this.language : <any>null;
        data["gender"] = this.gender !== undefined ? this.gender : <any>null;
        data["country"] = this.country !== undefined ? this.country : <any>null;
        data["latestEmail"] = this.latestEmail !== undefined ? this.latestEmail : <any>null;
        return data;
    }
}

export interface IUpdateProfileRequest {
    firstName?: string | null;
    lastName?: string | null;
    birthDate?: Date | null;
    language: string;
    gender?: Gender | null;
    country?: string | null;
    latestEmail?: string | null;
}

export class UpdateProfileTagRequest implements IUpdateProfileTagRequest {
    tags?: { [key: string]: string; } | null;

    constructor(data?: IUpdateProfileTagRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (_data["tags"]) {
                this.tags = {} as any;
                for (let key in _data["tags"]) {
                    if (_data["tags"].hasOwnProperty(key))
                        (<any>this.tags)![key] = _data["tags"][key] !== undefined ? _data["tags"][key] : <any>null;
                }
            }
            else {
                this.tags = <any>null;
            }
        }
    }

    static fromJS(data: any): UpdateProfileTagRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateProfileTagRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.tags) {
            data["tags"] = {};
            for (let key in this.tags) {
                if (this.tags.hasOwnProperty(key))
                    (<any>data["tags"])[key] = this.tags[key] !== undefined ? this.tags[key] : <any>null;
            }
        }
        return data;
    }
}

export interface IUpdateProfileTagRequest {
    tags?: { [key: string]: string; } | null;
}

export class UpdateProfileWhenOnboardingRequest implements IUpdateProfileWhenOnboardingRequest {
    firstName?: string | null;
    lastName?: string | null;
    birthDate?: Date | null;
    gender?: Gender | null;
    language?: string | null;
    email?: string | null;
    tags?: { [key: string]: string; } | null;

    constructor(data?: IUpdateProfileWhenOnboardingRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.firstName = _data["firstName"] !== undefined ? _data["firstName"] : <any>null;
            this.lastName = _data["lastName"] !== undefined ? _data["lastName"] : <any>null;
            this.birthDate = _data["birthDate"] ? new Date(_data["birthDate"].toString()) : <any>null;
            this.gender = _data["gender"] !== undefined ? _data["gender"] : <any>null;
            this.language = _data["language"] !== undefined ? _data["language"] : <any>null;
            this.email = _data["email"] !== undefined ? _data["email"] : <any>null;
            if (_data["tags"]) {
                this.tags = {} as any;
                for (let key in _data["tags"]) {
                    if (_data["tags"].hasOwnProperty(key))
                        (<any>this.tags)![key] = _data["tags"][key] !== undefined ? _data["tags"][key] : <any>null;
                }
            }
            else {
                this.tags = <any>null;
            }
        }
    }

    static fromJS(data: any): UpdateProfileWhenOnboardingRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateProfileWhenOnboardingRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["firstName"] = this.firstName !== undefined ? this.firstName : <any>null;
        data["lastName"] = this.lastName !== undefined ? this.lastName : <any>null;
        data["birthDate"] = this.birthDate ? this.birthDate.toISOString() : <any>null;
        data["gender"] = this.gender !== undefined ? this.gender : <any>null;
        data["language"] = this.language !== undefined ? this.language : <any>null;
        data["email"] = this.email !== undefined ? this.email : <any>null;
        if (this.tags) {
            data["tags"] = {};
            for (let key in this.tags) {
                if (this.tags.hasOwnProperty(key))
                    (<any>data["tags"])[key] = this.tags[key] !== undefined ? this.tags[key] : <any>null;
            }
        }
        return data;
    }
}

export interface IUpdateProfileWhenOnboardingRequest {
    firstName?: string | null;
    lastName?: string | null;
    birthDate?: Date | null;
    gender?: Gender | null;
    language?: string | null;
    email?: string | null;
    tags?: { [key: string]: string; } | null;
}

export class UpdateUserTagRequest implements IUpdateUserTagRequest {
    accountId?: string | null;
    tag?: string | null;
    value?: string | null;

    constructor(data?: IUpdateUserTagRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accountId = _data["accountId"] !== undefined ? _data["accountId"] : <any>null;
            this.tag = _data["tag"] !== undefined ? _data["tag"] : <any>null;
            this.value = _data["value"] !== undefined ? _data["value"] : <any>null;
        }
    }

    static fromJS(data: any): UpdateUserTagRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateUserTagRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accountId"] = this.accountId !== undefined ? this.accountId : <any>null;
        data["tag"] = this.tag !== undefined ? this.tag : <any>null;
        data["value"] = this.value !== undefined ? this.value : <any>null;
        return data;
    }
}

export interface IUpdateUserTagRequest {
    accountId?: string | null;
    tag?: string | null;
    value?: string | null;
}

export class UpsertUserTagRequest implements IUpsertUserTagRequest {
    accountId?: string | null;
    tag?: string | null;
    value?: string | null;

    constructor(data?: IUpsertUserTagRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accountId = _data["accountId"] !== undefined ? _data["accountId"] : <any>null;
            this.tag = _data["tag"] !== undefined ? _data["tag"] : <any>null;
            this.value = _data["value"] !== undefined ? _data["value"] : <any>null;
        }
    }

    static fromJS(data: any): UpsertUserTagRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpsertUserTagRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accountId"] = this.accountId !== undefined ? this.accountId : <any>null;
        data["tag"] = this.tag !== undefined ? this.tag : <any>null;
        data["value"] = this.value !== undefined ? this.value : <any>null;
        return data;
    }
}

export interface IUpsertUserTagRequest {
    accountId?: string | null;
    tag?: string | null;
    value?: string | null;
}

export class User implements IUser {
    _id?: string | null;
    phone?: string | null;
    phoneObject?: UserPhoneObject | null;
    name?: string | null;
    email?: string | null;
    language?: string | null;
    country?: string | null;
    staff_id?: string | null;
    role_id?: string | null;
    lat?: any | null;
    lng?: any | null;
    updatedAt?: Date | null;
    createdAt?: Date | null;
    isSourceAWS?: boolean | null;
    avatar?: string | null;
    first_time_cheating?: string | null;
    bar_id?: string | null;
    is_blocked_redemption?: boolean | null;
    exclude_campaign?: boolean | null;

    constructor(data?: IUser) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this._id = _data["_id"] !== undefined ? _data["_id"] : <any>null;
            this.phone = _data["phone"] !== undefined ? _data["phone"] : <any>null;
            this.phoneObject = _data["phoneObject"] ? UserPhoneObject.fromJS(_data["phoneObject"]) : <any>null;
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.email = _data["email"] !== undefined ? _data["email"] : <any>null;
            this.language = _data["language"] !== undefined ? _data["language"] : <any>null;
            this.country = _data["country"] !== undefined ? _data["country"] : <any>null;
            this.staff_id = _data["staff_id"] !== undefined ? _data["staff_id"] : <any>null;
            this.role_id = _data["role_id"] !== undefined ? _data["role_id"] : <any>null;
            this.lat = _data["lat"] !== undefined ? _data["lat"] : <any>null;
            this.lng = _data["lng"] !== undefined ? _data["lng"] : <any>null;
            this.updatedAt = _data["updatedAt"] ? new Date(_data["updatedAt"].toString()) : <any>null;
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : <any>null;
            this.isSourceAWS = _data["isSourceAWS"] !== undefined ? _data["isSourceAWS"] : <any>null;
            this.avatar = _data["avatar"] !== undefined ? _data["avatar"] : <any>null;
            this.first_time_cheating = _data["first_time_cheating"] !== undefined ? _data["first_time_cheating"] : <any>null;
            this.bar_id = _data["bar_id"] !== undefined ? _data["bar_id"] : <any>null;
            this.is_blocked_redemption = _data["is_blocked_redemption"] !== undefined ? _data["is_blocked_redemption"] : <any>null;
            this.exclude_campaign = _data["exclude_campaign"] !== undefined ? _data["exclude_campaign"] : <any>null;
        }
    }

    static fromJS(data: any): User {
        data = typeof data === 'object' ? data : {};
        let result = new User();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["_id"] = this._id !== undefined ? this._id : <any>null;
        data["phone"] = this.phone !== undefined ? this.phone : <any>null;
        data["phoneObject"] = this.phoneObject ? this.phoneObject.toJSON() : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["email"] = this.email !== undefined ? this.email : <any>null;
        data["language"] = this.language !== undefined ? this.language : <any>null;
        data["country"] = this.country !== undefined ? this.country : <any>null;
        data["staff_id"] = this.staff_id !== undefined ? this.staff_id : <any>null;
        data["role_id"] = this.role_id !== undefined ? this.role_id : <any>null;
        data["lat"] = this.lat !== undefined ? this.lat : <any>null;
        data["lng"] = this.lng !== undefined ? this.lng : <any>null;
        data["updatedAt"] = this.updatedAt ? this.updatedAt.toISOString() : <any>null;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : <any>null;
        data["isSourceAWS"] = this.isSourceAWS !== undefined ? this.isSourceAWS : <any>null;
        data["avatar"] = this.avatar !== undefined ? this.avatar : <any>null;
        data["first_time_cheating"] = this.first_time_cheating !== undefined ? this.first_time_cheating : <any>null;
        data["bar_id"] = this.bar_id !== undefined ? this.bar_id : <any>null;
        data["is_blocked_redemption"] = this.is_blocked_redemption !== undefined ? this.is_blocked_redemption : <any>null;
        data["exclude_campaign"] = this.exclude_campaign !== undefined ? this.exclude_campaign : <any>null;
        return data;
    }
}

export interface IUser {
    _id?: string | null;
    phone?: string | null;
    phoneObject?: UserPhoneObject | null;
    name?: string | null;
    email?: string | null;
    language?: string | null;
    country?: string | null;
    staff_id?: string | null;
    role_id?: string | null;
    lat?: any | null;
    lng?: any | null;
    updatedAt?: Date | null;
    createdAt?: Date | null;
    isSourceAWS?: boolean | null;
    avatar?: string | null;
    first_time_cheating?: string | null;
    bar_id?: string | null;
    is_blocked_redemption?: boolean | null;
    exclude_campaign?: boolean | null;
}

export class UserConfiguration implements IUserConfiguration {
    userId?: string | null;
    configs?: ConfigItem[] | null;

    constructor(data?: IUserConfiguration) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"] !== undefined ? _data["userId"] : <any>null;
            if (Array.isArray(_data["configs"])) {
                this.configs = [] as any;
                for (let item of _data["configs"])
                    this.configs!.push(ConfigItem.fromJS(item));
            }
            else {
                this.configs = <any>null;
            }
        }
    }

    static fromJS(data: any): UserConfiguration {
        data = typeof data === 'object' ? data : {};
        let result = new UserConfiguration();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId !== undefined ? this.userId : <any>null;
        if (Array.isArray(this.configs)) {
            data["configs"] = [];
            for (let item of this.configs)
                data["configs"].push(item.toJSON());
        }
        return data;
    }
}

export interface IUserConfiguration {
    userId?: string | null;
    configs?: ConfigItem[] | null;
}

export class UserGroup implements IUserGroup {
    /** Name of the group (also acts as ID - needs to be unique) */
    name?: string | null;
    description?: string | null;
    id?: string | null;
    createdAt?: Date | null;
    updatedAt?: Date | null;

    constructor(data?: IUserGroup) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.description = _data["description"] !== undefined ? _data["description"] : <any>null;
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : <any>null;
            this.updatedAt = _data["updatedAt"] ? new Date(_data["updatedAt"].toString()) : <any>null;
        }
    }

    static fromJS(data: any): UserGroup {
        data = typeof data === 'object' ? data : {};
        let result = new UserGroup();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["description"] = this.description !== undefined ? this.description : <any>null;
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : <any>null;
        data["updatedAt"] = this.updatedAt ? this.updatedAt.toISOString() : <any>null;
        return data;
    }
}

export interface IUserGroup {
    /** Name of the group (also acts as ID - needs to be unique) */
    name?: string | null;
    description?: string | null;
    id?: string | null;
    createdAt?: Date | null;
    updatedAt?: Date | null;
}

export class UserGroupInfo implements IUserGroupInfo {
    id?: string | null;
    name?: string | null;
    description?: string | null;
    userCount?: number | null;

    constructor(data?: IUserGroupInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.description = _data["description"] !== undefined ? _data["description"] : <any>null;
            this.userCount = _data["userCount"] !== undefined ? _data["userCount"] : <any>null;
        }
    }

    static fromJS(data: any): UserGroupInfo {
        data = typeof data === 'object' ? data : {};
        let result = new UserGroupInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["description"] = this.description !== undefined ? this.description : <any>null;
        data["userCount"] = this.userCount !== undefined ? this.userCount : <any>null;
        return data;
    }
}

export interface IUserGroupInfo {
    id?: string | null;
    name?: string | null;
    description?: string | null;
    userCount?: number | null;
}

export class UserLabel implements IUserLabel {
    accountId?: string | null;
    label?: string | null;
    id?: string | null;
    createdAt?: Date | null;
    updatedAt?: Date | null;

    constructor(data?: IUserLabel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accountId = _data["accountId"] !== undefined ? _data["accountId"] : <any>null;
            this.label = _data["label"] !== undefined ? _data["label"] : <any>null;
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : <any>null;
            this.updatedAt = _data["updatedAt"] ? new Date(_data["updatedAt"].toString()) : <any>null;
        }
    }

    static fromJS(data: any): UserLabel {
        data = typeof data === 'object' ? data : {};
        let result = new UserLabel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accountId"] = this.accountId !== undefined ? this.accountId : <any>null;
        data["label"] = this.label !== undefined ? this.label : <any>null;
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : <any>null;
        data["updatedAt"] = this.updatedAt ? this.updatedAt.toISOString() : <any>null;
        return data;
    }
}

export interface IUserLabel {
    accountId?: string | null;
    label?: string | null;
    id?: string | null;
    createdAt?: Date | null;
    updatedAt?: Date | null;
}

export class UserPhoneObject implements IUserPhoneObject {
    countryCode?: string | null;
    number?: string | null;

    constructor(data?: IUserPhoneObject) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.countryCode = _data["countryCode"] !== undefined ? _data["countryCode"] : <any>null;
            this.number = _data["number"] !== undefined ? _data["number"] : <any>null;
        }
    }

    static fromJS(data: any): UserPhoneObject {
        data = typeof data === 'object' ? data : {};
        let result = new UserPhoneObject();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["countryCode"] = this.countryCode !== undefined ? this.countryCode : <any>null;
        data["number"] = this.number !== undefined ? this.number : <any>null;
        return data;
    }
}

export interface IUserPhoneObject {
    countryCode?: string | null;
    number?: string | null;
}

export class UserSession implements IUserSession {
    accountId?: string | null;
    status?: UserSessionStatus | null;
    phoneDeviceId?: string | null;
    applicationId?: string | null;
    applicationName?: string | null;
    operatingSystem?: string | null;
    id?: string | null;
    createdAt?: Date | null;
    updatedAt?: Date | null;

    constructor(data?: IUserSession) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accountId = _data["accountId"] !== undefined ? _data["accountId"] : <any>null;
            this.status = _data["status"] !== undefined ? _data["status"] : <any>null;
            this.phoneDeviceId = _data["phoneDeviceId"] !== undefined ? _data["phoneDeviceId"] : <any>null;
            this.applicationId = _data["applicationId"] !== undefined ? _data["applicationId"] : <any>null;
            this.applicationName = _data["applicationName"] !== undefined ? _data["applicationName"] : <any>null;
            this.operatingSystem = _data["operatingSystem"] !== undefined ? _data["operatingSystem"] : <any>null;
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : <any>null;
            this.updatedAt = _data["updatedAt"] ? new Date(_data["updatedAt"].toString()) : <any>null;
        }
    }

    static fromJS(data: any): UserSession {
        data = typeof data === 'object' ? data : {};
        let result = new UserSession();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accountId"] = this.accountId !== undefined ? this.accountId : <any>null;
        data["status"] = this.status !== undefined ? this.status : <any>null;
        data["phoneDeviceId"] = this.phoneDeviceId !== undefined ? this.phoneDeviceId : <any>null;
        data["applicationId"] = this.applicationId !== undefined ? this.applicationId : <any>null;
        data["applicationName"] = this.applicationName !== undefined ? this.applicationName : <any>null;
        data["operatingSystem"] = this.operatingSystem !== undefined ? this.operatingSystem : <any>null;
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : <any>null;
        data["updatedAt"] = this.updatedAt ? this.updatedAt.toISOString() : <any>null;
        return data;
    }
}

export interface IUserSession {
    accountId?: string | null;
    status?: UserSessionStatus | null;
    phoneDeviceId?: string | null;
    applicationId?: string | null;
    applicationName?: string | null;
    operatingSystem?: string | null;
    id?: string | null;
    createdAt?: Date | null;
    updatedAt?: Date | null;
}

export enum UserSessionStatus {
    Disabled = "Disabled",
    Active = "Active",
}

export class UserTag implements IUserTag {
    accountId?: string | null;
    tag?: string | null;
    value?: string | null;
    id?: string | null;
    createdAt?: Date | null;
    updatedAt?: Date | null;

    constructor(data?: IUserTag) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accountId = _data["accountId"] !== undefined ? _data["accountId"] : <any>null;
            this.tag = _data["tag"] !== undefined ? _data["tag"] : <any>null;
            this.value = _data["value"] !== undefined ? _data["value"] : <any>null;
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : <any>null;
            this.updatedAt = _data["updatedAt"] ? new Date(_data["updatedAt"].toString()) : <any>null;
        }
    }

    static fromJS(data: any): UserTag {
        data = typeof data === 'object' ? data : {};
        let result = new UserTag();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accountId"] = this.accountId !== undefined ? this.accountId : <any>null;
        data["tag"] = this.tag !== undefined ? this.tag : <any>null;
        data["value"] = this.value !== undefined ? this.value : <any>null;
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : <any>null;
        data["updatedAt"] = this.updatedAt ? this.updatedAt.toISOString() : <any>null;
        return data;
    }
}

export interface IUserTag {
    accountId?: string | null;
    tag?: string | null;
    value?: string | null;
    id?: string | null;
    createdAt?: Date | null;
    updatedAt?: Date | null;
}

export class SwaggerException extends Error {
    override message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isSwaggerException = true;

    static isSwaggerException(obj: any): obj is SwaggerException {
        return obj.isSwaggerException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): Observable<any> {
    if (result !== null && result !== undefined)
        return _observableThrow(result);
    else
        return _observableThrow(new SwaggerException(message, status, response, headers, null));
}

function blobToText(blob: any): Observable<string> {
    return new Observable<string>((observer: any) => {
        if (!blob) {
            observer.next("");
            observer.complete();
        } else {
            let reader = new FileReader();
            reader.onload = event => {
                observer.next((event.target as any).result);
                observer.complete();
            };
            reader.readAsText(blob);
        }
    });
}